import { useState, useContext, useEffect } from 'react'
import Button from '../components/Button';
import Helper from '../utils/Helper'
// import cartContext from '../store/cart-context';

// var seqCheck = false;

const DOMHandler = () => {
    const helperFunc = Helper()

    const [calloutInfo, setcalloutInfo] = useState(true);
    const [camUpdate, setCamUpdate] = useState("!walloven_cam");


    let cameraNoResetMatrix = {
        'cooktop_cam': ['otc_micro_cam', 'OVER_THE_RANGE', 'range_hood_cam', 'walloven_cam','drawer_cam'],
        'dishwasher_cam': ['drawer_cam', 'microdrawer_cam', 'WALLOVEN_ZONE3'],
        'drawer_cam': ['dishwasher_cam', 'microdrawer_cam', 'reset', 'WALLOVEN_ZONE3','walloven_cam'],
        'microdrawer_cam': ['dishwasher_cam', 'drawer_cam', 'reset', 'WALLOVEN_ZONE3','walloven_cam'],
        'otc_micro_cam': ['cooktop_cam', 'OVER_THE_RANGE', 'range_hood_cam', 'refrigerator_cam', 'walloven_cam'],
        'OVER_THE_RANGE': ['cooktop_cam', 'otc_micro_cam', 'range_hood_cam', 'walloven_cam'],
        'range_hood_cam': ['cooktop_cam', 'otc_micro_cam', 'OVER_THE_RANGE', 'walloven_cam'],
        'refrigerator_cam': ['otc_micro_cam', 'reset'],
        'walloven_cam': ['cooktop_cam', 'otc_micro_cam', 'OVER_THE_RANGE', 'range_hood_cam', 'WALLOVEN_ZONE3'],
        // 'reset': ['drawer_cam', 'microdrawer_cam', 'WALLOVEN_ZONE3','drawer_zone7'],
        'reset': ['drawer_cam', 'microdrawer_cam', 'WALLOVEN_ZONE3'],
        'walloven_cam_zone3': ['dishwasher_cam', 'drawer_cam', 'reset'],
        // 'drawer_zone7': ['cooktop_cam', 'OVER_THE_RANGE', 'range_hood_cam','walloven_cam', 'WALLOVEN_ZONE3', 'microdrawer_cam'] \\n removed cooktop cam for intersection from drawer_zone7 to cooktop 
        'drawer_zone7': ['OVER_THE_RANGE', 'range_hood_cam','walloven_cam', 'WALLOVEN_ZONE3', 'microdrawer_cam',]
    }

    let nameOf3dObjArray=['Walloven_Location_F_HOTSPOT_01','Walloven_Location_F_HOTSPOT_02','Walloven_Location_R_HOTSPOT_01','Walloven_Location_R_HOTSPOT_02','Pedestals_Location_R_HOTSPOT_01','Pedestals_Location_F_HOTSPOT_01','remove_pedestal_zone_7-0','remove_pedestal_zone_3-0']
    let pedestalHotspot=['Pedestals_Location_R_HOTSPOT_01','Pedestals_Location_F_HOTSPOT_01']
    let pedestalVisCam = ['cooktop_cam','dishwasher_cam','drawer_zone7','microdrawer_cam','otc_micro_cam','OVER_THE_RANGE','range_hood_cam','refrigerator_cam','walloven_cam']
    
    const pedestalIntersectCams = ['cooktop_cam','range_hood_cam','otc_micro_cam','OVER_THE_RANGE'];
    const popUpVisibiltyCams = ['cooktop_cam','dishwasher_cam','otc_micro_cam','OVER_THE_RANGE','range_hood_cam','refrigerator_cam','walloven_cam'];

    let incomptabilePedestalTwoCheckES = document.querySelector('.SKMD24U0ES.menuItem');
    let incomptabilePedestalTwoCheckGS = document.querySelector('.SKCD24U0GS.menuItem');


    // let opacityFlag; // this is added for the opacity only/-

    // const cartCtx = useContext(cartContext);
    //My Kitchen Handler
    const [myKitchenPopupVisibility, setMyKitchenPopupVisibility] = useState(false)
    const handleMyKitchenVisibility = () => { myKitchenPopupVisibility ? setMyKitchenPopupVisibility(false) : setMyKitchenPopupVisibility(true) }

    // const [calloutInfo,setcalloutInfo]=useState(false);
    const [activeCalloutUserClosed, setActiveCalloutUserClosed] = useState([])
    const handleCalloutsInfo = (e, data) => {
        calloutInfo ? setcalloutInfo(false) : setcalloutInfo(true);

        setActiveCalloutUserClosed(e.target.parentElement.parentElement);
        let internalCalloutsAndHotspotsVisibility = document.querySelector('#internalCalloutsAndHotspots').style.display
        let calloutsContainerVisibility = document.querySelector('.calloutsContainer.active');
        calloutsContainerVisibility.classList.remove('active');
    }

    const handleCalloutsInfoBtnHandler = (e, data) => {
        calloutInfo ? setcalloutInfo(false) : setcalloutInfo(true);
        activeCalloutUserClosed.classList.add('active');
    }

    //How to navigate Handler
    const [howToNavigatePopupVisibility,setHowToNavigatePopupVisibility] = useState(false)
    const handlehowToNavigateVisibility = () => {
        howToNavigatePopupVisibility ? setHowToNavigatePopupVisibility(false) : setHowToNavigatePopupVisibility(true)
    }
    //Main Menu Open Close Handler
    const [mainMenuVisibility, setMainMenuVisibility] = useState(true)
    const handlehMainMenuVisibility = () => {
        mainMenuVisibility ? setMainMenuVisibility(false) : setMainMenuVisibility(true)

        if(mainMenuVisibility){
            if(document.querySelector('.KitchenNavigationButton')) document.querySelector('.KitchenNavigationButton').style.display = "none"
        }else{
            if(document.querySelector('.KitchenNavigationButton')) document.querySelector('.KitchenNavigationButton').style.display = "block"
        }
    }

    // Accordion expand collapse handler for accordion in callouts

    const [calloutAccExpand, setcalloutAcExpand] = useState(false)

    // const checkForOverLay = () => {
    //     if (opacityFlag == true) {
    //             document.getElementById('overLay').style.display = 'block';
    //     }
    //     else if (opacityFlag == false) {
    //            setTimeout(()=>{
    //         document.getElementById('overLay').style.display = 'none';
    //       },3000)
    //     }
    // }

    //function to handle the callout box functionality
    const handleCalloutAccordion = (event, data) => {
    // let curentTargetCallout = event.target.closest('button'); //1

        let curentTargetCallout = document.getElementById(data.id + 'Btn')
        let currentTargetCalloutActive = curentTargetCallout.classList.contains('active') //2

        let siblingAccordionContentCallout = curentTargetCallout.parentElement.nextElementSibling //3
        let siblingAccordionContentHeightCallout = helperFunc.menuItemHeightCalc(siblingAccordionContentCallout.childNodes)
        if (currentTargetCalloutActive) {
        
            curentTargetCallout.classList.remove('active') //4
            siblingAccordionContentCallout.classList.remove('expandCallout')
            siblingAccordionContentHeightCallout = 0 //5

            // if(data.id == "SCH2443GB-ViewControlPanel2"){
                // ------------------
                // window.hotspotsList.setHotspotsActive([   
                // { hsname: "SCH2443GB-ViewControlPanel-WhiteHotspotAdvancedSafetyFeatures", isactive: false }
                // ])
                // ------------------
            // }

        } else {
                //Remove classes of other active accordion
                if (document.querySelector('.accordionContentContainer.expandCallout') !=null && document.querySelector('.accordionHeading.active') != null) {

                    let getOtherActiveCalloutAccordion = document.querySelector('.accordionContentContainer.expandCallout')
                    let getOtherActiveCalloutAccordionBtn = document.querySelector('.calloutsContainer.active .accordionHeading.active')

                    if (getOtherActiveCalloutAccordion != null)
                        getOtherActiveCalloutAccordion.classList.remove('expandCallout')
                    if (getOtherActiveCalloutAccordionBtn != null)
                        getOtherActiveCalloutAccordionBtn.classList.remove('active')
                        getOtherActiveCalloutAccordion.style.height = '0px'
                }
                
                // ------------------
                // window.hotspotsList.setHotspotsActive([   
                //     { hsname: "SCH2443GB-ViewControlPanel-WhiteHotspotAdvancedSafetyFeatures", isactive: false }
                //     ])
                // console.log("data",data);
                // handleWhitehotspotVis(data);
                // -------------------

                // if(data.id == "SCH2443GB-ViewControlPanel2"){
                //     window.hotspotsList.setHotspotsActive([   
                //     { hsname: "SCH2443GB-ViewControlPanel-WhiteHotspotAdvancedSafetyFeatures", isactive: true }
                //     ])
                // }
                
                    
                // ---------------------camera for whitehotspot's
                // camera for accordion click will work fro here only/-
                // if(data.hotspotCamera != "")
                // window.scene.applySequence(window[data.hotspotCamera], function () {
                //     setTimeout(()=>{
                      
                //     },100)
                // })
                // ----------------------
                
                curentTargetCallout.classList.add('active') //6
                siblingAccordionContentCallout.classList.add('expandCallout')
            }

            siblingAccordionContentCallout.style.height = siblingAccordionContentHeightCallout + 'px'
    }

    //function to handle the internal/external hotspots visibility based on different clicks
    const handleHotspotsVisibility = (data,event) => {
     


        if(data.productStateSelectContext.pedestalsPosition === "zoneSeven"){
            setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
                    ])
            },1000)
        }
        
        if(data.id == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneThree"){
            setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                    ])
            },1000)
        }

        // if(data.productStateSelectContext.pedestalsPosition == "zoneSeven" && data?.cardDetails?.title == "Remove the pedestal" && data.itemCategory == "underTheCounterPedestalsCategory"){
        if(data?.cardDetails?.title == "Remove the pedestal" && data.itemCategory == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneSeven"){  
           
            window.hotspotsList.setHotspotsActive([
                    { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false }
                    ])
        }
       
        if(data?.cardDetails?.title == "Remove the pedestal" && data.itemCategory == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneThree"){
            
            // setTimeout(() => {
                // window.hotspotsList.setHotspotsActive([
                //     { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                //     ])
                //    if(document.getElementById('underTheCounterPedestalsCategory-hotspotBtn')) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.opacity = 1;
            // }, 1000);
        
        }

        if(data.productStateSelectContext.wallOvenPosition === "zoneThree" && data.productStateSelectContext.pedestalsPosition === "zoneThree"){
            window.hotspotsList.setHotspotsActive([
                { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: true },
                { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }
                ]);
        }

        if(data.productStateSelectContext.pedestalsPosition == "zoneThree" && data?.cardDetails?.title == "Remove the pedestal" && data.itemCategory == "underTheCounterPedestalsCategory"){
         
            window.hotspotsList.setHotspotsActive([
                { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: true },
                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                ])
        };


        if(data.id == "underTheCounterPedestalsCategoryRight" && data.productStateSelectContext.pedestalsPosition == "zoneThree"){
        
                window.hotspotsList.setHotspotsActive([
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                    ])
        }
       
        if(event?.target?.id == "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn"){
            window.hotspotsList.setHotspotsActive([
                { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: true }
                ])
        }

        if(data.productStateSelectContext.previousCam == "range_hood_cam"){
            document.getElementById('hoodRangeCategory-hotspotBtn').style.visibility = "visible";
            document.getElementById('overRangeMicroCategory-hotspotBtn').style.visibility = "hidden";
        }else if(data.productStateSelectContext.previousCam == "OVER_THE_RANGE"){
            document.getElementById('hoodRangeCategory-hotspotBtn').style.visibility = "hidden";
            document.getElementById('overRangeMicroCategory-hotspotBtn').style.visibility = "visible";
        }
       
        if (data.id == "cooktopCategory" || data.itemCategory == "cooktopCategory") {

            if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
             
                setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "overRangeMicroCategory-hotspotBtn", isactive: true },
                    { hsname: "cooktopCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "hoodRangeCategory-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                    //  it means walloven is present in the right side
                    { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
                ])
            },10)
            }

            if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
                window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT';
        
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "overRangeMicroCategory-hotspotBtn", isactive: true },
                        { hsname: "cooktopCategory-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                        { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                        { hsname: "hoodRangeCategory-hotspotBtn", isactive: true },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false }
                    ])
                },10)
            }
            if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "installWallovenOneInFront-hotspotBtn", isactive: true },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
                        ])
                },10)
            }
            if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }
                        ])
                },10)
            }
     
            window.hotspotsList.setHotspotsActive([
                { hsname: "overRangeMicroCategory-hotspotBtn", isactive: true },
                { hsname: "cooktopCategory-hotspotBtn", isactive: false },
                { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                { hsname: "hoodRangeCategory-hotspotBtn", isactive: true },
                { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                { hsname: "overTheCounterCategory-hotspotBtn", isactive: false }
            ])
        }
        else if (data.id == "hoodRangeCategory" || data.itemCategory == "hoodRangeCategory") {
            setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "hoodRangeCategory-hotspotBtn", isactive: false },
                    { hsname: "overRangeMicroCategory-hotspotBtn", isactive: false },
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                    { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false }
                ])
            },10)
          
        }
        else if (data.id == "overRangeMicroCategory" || data.itemCategory == "overRangeMicroCategory") {
            setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "overRangeMicroCategory-hotspotBtn", isactive: false },
                    { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                    { hsname: "hoodRangeCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                    { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false }
                ])
            },10)
        }
        else if (((data.id == "underTheCounterPedestalsCategory" || data.id == "remove_pedestal_zone_7" || data.id == "underTheCounterPedestalsCategoryRight") && data.productStateSelectContext.pedestalsPosition == "zoneSeven") 
        || (data.itemCategory == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneSeven")) {
            window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT'
            if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
            
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                        { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                        { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false }
                        
                    ])
                },10)
              
            }

            if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
     
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                        { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                        { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false }
                    ])
                },10)
            }

            if(data.productStateSelectContext.pedestalsPosition === "zoneSeven"){
          
                window.hotspotsList.setHotspotsActive([
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                    { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false }
                ])
            }

            if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
      
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                        { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                        { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false }
                    ])
                },10)
      
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false }
                    ])
                },1000)
                
            }
        }
        else if (((data.id == "underTheCounterPedestalsCategory" || data.id == "remove_pedestal_zone_7" || data.id == "underTheCounterPedestalsCategoryRight")&& data.productStateSelectContext.pedestalsPosition == "zoneThree" )
        || (data.itemCategory == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneThree")) {
            if((data.productStateSelectContext.microwaveDrawerOvensCategory == "" 
            || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& data.productStateSelectContext.wallOvenPosition == "zoneThree"){
                
                window.hotspotsList.setHotspotsActive([
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false }
                ])
            }
            else if((data.productStateSelectContext.underTheCounterPedestalsCategory != "" 
            || data.productStateSelectContext.underTheCounterPedestalsCategory != "Remove the pedestal" )
            && data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory != ""){
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                        // { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                    ])
                },2000) // this delay is added so when user comes from rangehood to ped it will hide the content
               
            }
           else if((data.productStateSelectContext.microwaveDrawerOvensCategory == "" 
            || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& 
            (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal")
            && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
            
                window.hotspotsList.setHotspotsActive([
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
                ])
            }
            else if(((data.productStateSelectContext.microwaveDrawerOvensCategory == "" 
            || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& 
            (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal"))
            && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
         
           
                window.hotspotsList.setHotspotsActive([
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: true }
                ])
            }
            else if(((data.productStateSelectContext.microwaveDrawerOvensCategory != "" 
            || data.productStateSelectContext.microwaveDrawerOvensCategory != "Remove the microwave drawer" )&&
            ((data.productStateSelectContext.underTheCounterPedestalsCategory != "" || data.productStateSelectContext.underTheCounterPedestalsCategory != "Remove the pedestal")))
            && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
        
                setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                ])
            },1000)
            }
            else if(((data.productStateSelectContext.microwaveDrawerOvensCategory != "" 
            || data.productStateSelectContext.microwaveDrawerOvensCategory != "Remove the microwave drawer" )&&
            (data.productStateSelectContext.underTheCounterPedestalsCategory != "" || data.productStateSelectContext.underTheCounterPedestalsCategory != "Remove the pedestal"))
            && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
                window.hotspotsList.setHotspotsActive([
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }, //
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
                ])
            }

            if(((data.productStateSelectContext.microwaveDrawerOvensCategory != "" 
            || data.productStateSelectContext.microwaveDrawerOvensCategory != "Remove the microwave drawer" )&&
            ((data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal")))
            && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
         
                window.hotspotsList.setHotspotsActive([
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }, // 
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: true }
                ])
            }

         if(((data.productStateSelectContext.microwaveDrawerOvensCategory != "" 
            || data.productStateSelectContext.microwaveDrawerOvensCategory != "Remove the microwave drawer" )&&
            ((data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal")))
            && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
          
                window.hotspotsList.setHotspotsActive([
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }, // 
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                    //@SH24JAN24CF added this condition as we no need to show the hotspot when the walloven already present in the zoneSeven
                    // { hsname: "installWalloneOneInright-hotspotBtn", isactive: true }
                ])
            }

            if( (data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal" || data.productStateSelectContext.underTheCounterPedestalsCategory == "" ) 
            && data.productStateSelectContext.microwaveDrawerOvensCategory != "" && data.productStateSelectContext.wallOvenPosition == "zoneSeven" &&
            (data.productStateSelectContext.wallOvenCategory == "SSC2489GS" || data.productStateSelectContext.wallOvenCategory == "SWA2450GS")
             ){
               
                window.hotspotsList.setHotspotsActive([
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
                ])
            }

            if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" && data.productStateSelectContext.wallOvenPosition == "zoneThree"
            && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){

                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                        // { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                    ])
                },2000)
                
            }
            else if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" && data.productStateSelectContext.wallOvenPosition == "zoneThree"
            && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                    ])
                },1000) 
            }
            else if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.wallOvenPosition == "zoneThree"
            && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
                 setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
                    ])
                 }, 2000);
            }
            else if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.wallOvenPosition == "zoneThree"
            && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
                 setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
                    ])
                 }, 1000);
            }

            if(data.productStateSelectContext.wallOvenCategory == "SSC2489GS" && data.productStateSelectContext.microwaveDrawerOvensCategory != "" && 
            data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.pedestalsPosition == "zoneThree"){

                if(document.getElementById('SKCD24U0GS') != null) document.getElementById('SKCD24U0GS').classList.add('opacityCard');
            }

          
        }
        else if (data.id == "overTheCounterCategory" || data.itemCategory == "overTheCounterCategory") {
     
            setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "overTheCounterCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "hoodRangeCategory-hotspotBtn", isactive: true },
                    { hsname: "overRangeMicroCategory-hotspotBtn", isactive: false },
                    { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                 
                ])

            },10)
        }
        else if (data.id == "refrigeratorCategory" || data.itemCategory == "refrigeratorCategory") {
     
            setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                    { hsname: "overTheCounterCategory-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                ])
            },10)

            if(data.productStateSelectContext.wallOvenPosition == "zoneThree"){
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: false }
                    ])
                },10)
            }
        }
        else if ((data.id == "wallOvenCategory" && data.productStateSelectContext.wallOvenPosition == "zoneSeven")
            || (data.itemCategory == "wallOvenCategory" && data.productStateSelectContext.wallOvenPosition == "zoneSeven")
            || (data.id == "installWallovenInFrontSide" && data.productStateSelectContext.wallOvenPosition == "zoneSeven")
            || (data.id == "installWallovenOneInFront"  && data.productStateSelectContext.wallOvenPosition == "zoneSeven")
            ) { 


            if(data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
           
             setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                    { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                    // zoneFlagpedestal && { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "installWallovenOneInFront-hotspotBtn", isactive: false },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                    { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: true }
                ])
             },10)
            }else if(data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
                
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                    ])
                 },10)

                //  const isremove_pedestal_zone_7Active =  window.getComputedStyle(document.getElementById('remove_pedestal_zone_7-hotspotBtn'))['display']
        
                //  console.log(isremove_pedestal_zone_7Active,'isremove_pedestal_zone_7Active---------')
                 if(data.productStateSelectContext.pedestalsPosition == 'zoneSeven' && data.productStateSelectContext.zoneSevenPedestalRemovedStatus === true){
                    
                     setTimeout(() => {
                         window.hotspotsList.setHotspotsActive([
                             { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }
                             ])
                     }, 2000);
                 }
            }
         
           if(data.productStateSelectContext.wallOvenCategory == "SSC2489GS" && data.productStateSelectContext.underTheCounterPedestalsCategory == ""){
 
            setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                        { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                        { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                    ])
                },1000)
            }

            if(data.productStateSelectContext.wallOvenCategory == "SSC2489GS" && data.productStateSelectContext.underTheCounterPedestalsCategory != ""){
                window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_zone7_HOTSPOT';
             
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                        { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                        { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                        { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "overTheCounterCategory-hotspotBtn", isactive: true }
                    ])
                },10)
            }
        
            window.hotspotsList.setHotspotsActive([
                { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                { hsname: "overTheCounterCategory-hotspotBtn", isactive: true },
            ])
        }
          if ((data.id == "wallOvenCategory" && data.productStateSelectContext.wallOvenPosition == "zoneThree")
            || (data.itemCategory == "wallOvenCategory" && data.productStateSelectContext.wallOvenPosition == "zoneThree")
            || (data.id == "installWallovenInrightSide" && data.productStateSelectContext.wallOvenPosition == "zoneThree")
            || (data.id == "installWalloneOneInright" && data.productStateSelectContext.wallOvenPosition == "zoneThree")
            ) { // for the walloven it should be for front side and right side
            
                window.hotspotsList.setHotspotsActive([
                    { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: true },
                ])
                // if (data.productStateSelectContext.pedestalsPosition == "zoneThree") {
                //     zoneFlagpedestal = false;
                // }
                if(data.productStateSelectContext.wallOvenCategory == "SSC2489GS" && data.productStateSelectContext.microwaveDrawerOvensCategory != ""){
                  
                    setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true }

                    ])
                 },10)
                }
                else if (data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
                    setTimeout(()=>{
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                            { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true },
                            { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                            { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                            { hsname: "installWallovenOneInFront-hotspotBtn", isactive: false },
                            { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: true }
                        ])
                     },10)
                }
                else if (data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
                    setTimeout(()=>{
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                            { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true },
                            { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                            { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                            { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false },
                            { hsname: "installWallovenOneInFront-hotspotBtn", isactive: true },
                            { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                        ])
                     },1000)
                }
                
                if(data.productStateSelectContext.wallOvenCategory == "SSC2489GS" && data.productStateSelectContext.microwaveDrawerOvensCategory == ""){
                
                    setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                        { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false }
                    ])
                 },1000)
                }
                else if( data.productStateSelectContext.wallOvenCategory == "SWA2450GS" && data.productStateSelectContext.microwaveDrawerOvensCategory == ""){
             
                    setTimeout(()=>{
                       window.hotspotsList.setHotspotsActive([
                           { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                           { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                           { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                           { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                           { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false }
                       ])
                    },1000)
                }
               else if(data.productStateSelectContext.wallOvenCategory == "SWA2450GS"  && data.productStateSelectContext.microwaveDrawerOvensCategory != ""){
            
                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                        { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false }
                    ])
                },1500)
                }
            
        }
        else if (data.id == "dishwasherCategory" || data.itemCategory == "dishwasherCategory") {
                setTimeout(()=>{
                window.hotspotsList.setHotspotsActive([
                        { hsname: "dishwasherCategory-hotspotBtn", isactive: false },
                        { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                        { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                        { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                        { hsname: "overTheCounterCategory-hotspotBtn", isactive: false }
                    ])
                },10)
        }
        else if (data.id == "microwaveDrawerOvensCategory" || data.itemCategory == "microwaveDrawerOvensCategory" || data.id == "installmicrowaveDrawerOven") {
  
            if((data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& 
            data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
               
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true }
                ])
            }

            if ((data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& 
            data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
               
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true } // 
                ])
            }
            else if ((data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& 
            data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
                
              setTimeout(() => {
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }, // 
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true } // 
                ])
              }, 10);
            }
            if ((data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& 
            data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
              
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true } // 
                ])
            }
            if((data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& 
            data.productStateSelectContext.wallOvenPosition == "zoneThree"){
           
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false}, // 
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false}
                ])
            }
            else if ((data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer")&& 
            data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
           
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true } //
                ])
            }
            if(data.productStateSelectContext.microwaveDrawerOvensCategory != "" && data.productStateSelectContext.wallOvenPosition == "zoneSeven" 
            && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
              
                // if( window.hotspotsList.hslist[8]!=undefined) window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_HOTSPOT_01'; #TPE
                if(window.hotspotsList.hslist[8]!=undefined){
                if(window.hotspotsList.hslist[8].hsname == "SMD2499FS-OpenDrawer-btn") window.hotspotsList.hslist[8].nameOf3dObj = 'SMD2499FS_HOTSPOT_01';
                }
              
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false},
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true},
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true} //
                ])
            }
            else if(data.productStateSelectContext.microwaveDrawerOvensCategory != "" && data.productStateSelectContext.wallOvenPosition == "zoneSeven" 
            && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
        
                // window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_HOTSPOT_01'; #TPE
             
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: false },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false},
                    { hsname: "dishwasherCategory-hotspotBtn", isactive: true},
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: true} //
                ])
            }
            else if(data.productStateSelectContext.microwaveDrawerOvensCategory != "" && data.productStateSelectContext.wallOvenPosition == "zoneThree"
            && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
             
                // window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_HOTSPOT_01'; #TPE
            
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false},
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false} 
                ])
            }
            else if(data.productStateSelectContext.microwaveDrawerOvensCategory != "" && data.productStateSelectContext.wallOvenPosition == "zoneThree"
            && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
             
                // window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_HOTSPOT_01'; #TPE
            
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false},
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false},
                    { hsname: "installWalloneOneInright-hotspotBtn", isactive: false} 
                ])
            }else if(data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer"){
          
                window.hotspotsList.setHotspotsActive([
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false}
                ])

            }

            if((data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory =="Remove the microwave drawer")&& data.productStateSelectContext.wallOvenPosition == "zoneThree"){
        
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true},
                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false} //
                ])
            }

            if((data.productStateSelectContext.microwaveDrawerOvensCategory == "" || data.productStateSelectContext.microwaveDrawerOvensCategory =="Remove the microwave drawer") && 
                data.productStateSelectContext.pedestalsPosition == "zoneThree" 
            ){
              
                window.hotspotsList.setHotspotsActive([
                    { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: true }
                ])
            }


            if((data.productStateSelectContext.microwaveDrawerOvensCategory != "" || data.productStateSelectContext.microwaveDrawerOvensCategory !="Remove the microwave drawer") && data.productStateSelectContext.pedestalsPosition == "zoneThree" &&
            (data.productStateSelectContext.underTheCounterPedestalsCategory != "" ||  data.productStateSelectContext.underTheCounterPedestalsCategory != "Remove the pedestal") && data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES !== true){
              
                window.hotspotsList.setHotspotsActive([
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true }
                ])
            }

        }

        else if( data.id == "installWallovenInrightSide"){
          
            window.hotspotsList.setHotspotsActive([
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
            ])
        }
        else if((data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS")
        || (data.wallOvenPosition == "zoneSeven" && data.wallOvenCategory == "SWA2450GS")  ){
         
            window.hotspotsList.setHotspotsActive([
                { hsname: "installWalloneOneInright-hotspotBtn", isactive: true },
                { hsname: "installWallovenOneInFront-hotspotBtn", isactive: false },
                { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false },
            ])
        }
        else if((data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS") ||
        (data.wallOvenPosition == "zoneThree" && data.wallOvenCategory == "SWA2450GS")){
            window.hotspotsList.setHotspotsActive([
                { hsname: "installWallovenOneInFront-hotspotBtn", isactive: true },
                { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
            ])
        }
        else if((data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS") ||
        (data.wallOvenPosition == "zoneSeven" && data.wallOvenCategory == "SSC2489GS")){
            window.hotspotsList.setHotspotsActive([
                { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: false },
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true },
                { hsname: "installWallovenOneInFront-hotspotBtn", isactive: false },
            ])
        }
        else if((data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS") || 
        (data.wallOvenPosition == "zoneThree" && data.wallOvenCategory == "SSC2489GS")){
            window.hotspotsList.setHotspotsActive([
                { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: true },
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                { hsname: "installWalloneOneInright-hotspotBtn", isactive: false }
            ])
        }

        if(data.id == "installmicrowaveDrawerOven"){
            window.hotspotsList.setHotspotsActive([
                { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false }
            ])
        }

        //added this condition to hide the front hotspot when pedestal is not present in the front
        if(data.productStateSelectContext.underTheCounterPedestalsCategory === "SKMD24U0ES" && data.productStateSelectContext.pedestalsPosition === "zoneThree" && data.productStateSelectContext.previousId === "underTheCounterPedestalsCategory"){
   
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }
            ])
        }

        setTimeout(function(){
            if (data.productStateSelectContext.pedestalsPosition == "zoneSeven") {
                if(document.querySelector('#underTheCounterPedestalsCategory-hotspotBtn span')!=null){
                    document.querySelector("#underTheCounterPedestalsCategory-hotspotBtn span").innerHTML = "Under-the-Counter Pedestals";
                }
                    data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"
            }
            else if(data.productStateSelectContext.pedestalsPosition == "zoneThree"){
                if(document.querySelector('#underTheCounterPedestalsCategory-hotspotBtn span')!=null){
                    // document.querySelector("#underTheCounterPedestalsCategory-hotspotBtn span").innerHTML = "Under-the-Microwave Pedestals Extra";
                }
            }
        },3000);
        if(document.querySelector('#Removethepedestal')!=null){
        if(document.querySelector('#Removethepedestal').classList.contains('active')){
          
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }
            ])
            
        }
    }

    if (((data.id == "underTheCounterPedestalsCategory" || data.id == "remove_pedestal_zone_7" || data.id == "underTheCounterPedestalsCategoryRight" || data.itemCategory == "underTheCounterPedestalsCategory") && data.productStateSelectContext.pedestalsPosition == "zoneThree" )
        || (data.itemCategory == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneThree")){

            if((data.productStateSelectContext.microwaveDrawerOvensCategory != "" || data.productStateSelectContext.microwaveDrawerOvensCategory != "Remove the microwave drawer" )
            && (data.productStateSelectContext.underTheCounterPedestalsCategory != "" ||data.productStateSelectContext.underTheCounterPedestalsCategory != "Remove the pedestal" )
            && data.productStateSelectContext.pedestalsPosition === "zoneThree"
            ){
         
                window.hotspotsList.setHotspotsActive([
                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                ])
            }
    }

    //added for hiding the hotspot when the pedestal is present in the front side
    if(data.itemCategory == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneSeven"
    && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" && data.cardDetails.title === "SKCD24U0GS"
    ){
        window.hotspotsList.setHotspotsActive([
            { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
        ])
    }

    //@SH24JAN24CF added this condition to hide and show the right pedestal hotspot
    if(data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES === true && data?.cardDetails?.title != "SKMD24U0ES" && 
    data?.itemCategory == "underTheCounterPedestalsCategory"
    ){
        // console.log('new Condition causing....')
  
        setTimeout(() => {
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: true }
            ])
        }, 1000);
    }else if(data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES !== true && data?.cardDetails?.title != "SKMD24U0ES" && 
    data?.itemCategory == "underTheCounterPedestalsCategory"){
   
        // console.log('new Condition causing....')
      

        setTimeout(() => {
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
            ])
        }, 1000);
    }

    if(data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES == false && data?.itemCategory == "underTheCounterPedestalsCategory" 
        && data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES"
    ){
      
        setTimeout(() => {
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
            ])
        }, 1000);
    }


    if(data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES !== true && data.productStateSelectContext.pedestalsPosition === "zoneSeven" && data.id != "underTheCounterPedestalsCategory"
     && data?.id !== "wallOvenCategory" && data?.id !== "hoodRangeCategory"){
        // console.log('new Condition causing....')
        
        setTimeout(() => {
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true }
            ])
        }, 1000);
    };

    if(data.productStateSelectContext.zoneSevenPedestalRemovedStatus == false && data.id === "underTheCounterPedestalsCategory"){
        setTimeout(() => {
            window.hotspotsList.setHotspotsActive([
                { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                ])
                // if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = 'visible';
        }, 2000);
    }

    if(data.productStateSelectContext.microwaveDrawerOvensCategory !== "" && data.productStateSelectContext.pedestalsPosition == "zoneThree"
    && data.id === "underTheCounterPedestalsCategory"
    ){
        window.hotspotsList.setHotspotsActive([
            { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false }
            ])
        
    }

    if(data.productStateSelectContext.microwaveDrawerOvensCategory !== "" && data.productStateSelectContext.pedestalsPosition == "zoneThree"
    && data.id === "underTheCounterPedestalsCategory"
    ){
   
     
        
    }

    if(data?.id == "installWallovenInrightSide" && data.productStateSelectContext.pedestalsPosition == "zoneThree" 
    && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" && data.productStateSelectContext.wallOvenPosition == "zoneThree"
    ){
        setTimeout(() => {
            window.hotspotsList.setHotspotsActive([
                { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                ])
        }, 1000);
     
    }

    // if(data?.id === "wallOvenCategory" && data?.productStateSelectContext.wallOvenPosition === "zoneSeven" && data.productStateSelectContext.wallOvenCategory === "SSC2489GS" &&
    // data?.productStateSelectContext?.pedestalsPosition == "zoneSeven"
    // ){
   
    //     setTimeout(() => {
    //                 window.hotspotsList.setHotspotsActive([
    //                     { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
    //                 ])
    //     }, 2000);
        
    // }

    // console.log(data.id)
    // if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.pedestalsPosition == "zoneThree"
    // && data.productStateSelectContext.microwaveDrawerOvensCategory !== "" && data.id !== "microwaveDrawerOvensCategory" && data.id === "remove_pedestal_zone_3"
    // ){
    //     setTimeout(() => {
    //         window.hotspotsList.setHotspotsActive([
    //             { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
    //         ])
    //     }, 2000);
    // }
    
        // console.log('data.productStateSelectContext.previousHotspotCam',data.productStateSelectContext.previousHotspotCam);
        data.productStateSelectContext.previousHotspotCam = data.productStateSelectContext.currentCam
    }

    //function to handle the cases if there is only one product in every category
    const distSingleProduct=(data)=>{
        if(data.id == "microwaveDrawerOvensCategory" && data?.menuItems[0]?.title == "SMD2499FS" && data.menuItemLength == 1){
            data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2499FS"
        }
        else if(data.id == "microwaveDrawerOvensCategory" && data?.menuItems[0]?.title == "SMD2470AS" && data.menuItemLength == 1){
            data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2470AS"
        }

        if(data.id == "wallOvenCategory" && data?.menuItems[0]?.title == "SWA2450GS" && data.menuItemLength == 1){
            data.productStateSelectContext.wallOvenCategory = "SWA2450GS";
            document.getElementById('SWA2450GS').classList.add('active');
        }
        if(data.id == "cooktopCategory" && data?.menuItems[0]?.title == "SCR2442FB" && data.menuItemLength == 1){
            data.productStateSelectContext.cooktopCategory = "SCR2442FB";
            document.getElementById('SCR2442FB').classList.add('active');
        }

        if(data.id == "dishwasherCategory" && data?.menuItems[0]?.title == "SDW6747GS" && data.menuItemLength == 1){
            data.productStateSelectContext.dishwasherCategory = "SDW6747GS";
            document.getElementById('SDW6747GS').classList.add('active');
        }
        else if(data.id == "dishwasherCategory" && data?.menuItems[0]?.title == "SDW6767HS" && data.menuItemLength == 1){
            data.productStateSelectContext.dishwasherCategory = "SDW6767HS";
            document.getElementById('SDW6767HS').classList.add('active');
        }

        if(data.id == "underTheCounterPedestalsCategory" && data?.menuItems[0]?.title == "SKMD24U0ES" && data.menuItemLength == 1){
            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
        }

    }
    // -----------------
    // const handleWhitehotspotVis = (data,event)=>{

    //     if(data.id == "SCH2443GB-ViewControlPanel2"){
    //         window.hotspotsList.setHotspotsActive([   
    //         { hsname: "SCH2443GB-ViewControlPanel-WhiteHotspotAdvancedSafetyFeatures", isactive: true }
    //         ])
    //     }

    // }
    // Accordion expand collapse handler
    const [accordionExpand, setaccordionExpand] = useState(false)
    //flag to check for specific condition related to front pedestal installation on hotspot click
    let isFrontInstalledAfterRightZoneWithGS = false;
    //main function which calls on accodian, icons, and onLoad hotspots and hotspots which are used to transfer the zone in one to another 
    const handleAccordionExpand = (event, data) => {
     


        if(window.mob){
            if(document.querySelector('.zoomoutButtonNew')) document.querySelector('.zoomoutButtonNew').style.display = "flex"
            if(document.getElementById('installWallovenInrightSide-hotspotBtn') != null) document.getElementById('installWallovenInrightSide-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('microwaveDrawerOvensCategory-hotspotBtn') != null) document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('underTheCounterPedestalsCategoryRight-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategoryRight-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('remove_pedestal_zone_3-hotspotBtn') != null) document.getElementById('remove_pedestal_zone_3-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('installmicrowaveDrawerOven-hotspotBtn') != null) document.getElementById('installmicrowaveDrawerOven-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('installWalloneOneInright-hotspotBtn') != null) document.getElementById('installWalloneOneInright-hotspotBtn').classList.remove('mobresetzonethreehs');

            if(data.wallOvenPosition == "zoneThree"){
                if(document.getElementById('wallOvenCategory-hotspotBtn') != null) document.getElementById('wallOvenCategory-hotspotBtn').classList.remove('mobresetzonethreehs');
           }
            
        }
   
       //@SH24JAN24CF added this condition to updated the flat to install the pedestal in the front side;
        if(data.productStateSelectContext.underTheCounterPedestalsCategory === "SKCD24U0GS" && data.productStateSelectContext.wallOvenPosition === "zoneThree"
            && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" && data.productStateSelectContext.pedestalsPosition == "zoneThree"
            && data.id  == "remove_pedestal_zone_7" )
        {
                isFrontInstalledAfterRightZoneWithGS = true;                        
        }else{
                isFrontInstalledAfterRightZoneWithGS = false;
        }

        // console.log("data.hotspotId 975",data.hotspotId);
        // console.log(" data.productStateSelectContext.pedestalsPosition 976", data.productStateSelectContext.pedestalsPosition);

        if(data.productStateSelectContext.previousId == "underTheCounterPedestalsCategoryhotspotAndCalloutRemove"  && data.id === "underTheCounterPedestalsCategoryRight" ){
            data.productStateSelectContext.pedestalsPosition = "zoneThree";
            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
            if(document.getElementById('Removethepedestal')) document.getElementById('Removethepedestal').classList.remove('active');
        }
        else if(data.id === "underTheCounterPedestalsCategoryRight" && data.productStateSelectContext.microwaveDrawerOvensCategory !== "SMD2499FS"){
            data.productStateSelectContext.pedestalsPosition = "zoneThree";
            
            if(data.productStateSelectContext.zoneSevenPedestalRemovedStatus !== true){
                data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
            }

            if(data.productStateSelectContext.underTheCounterPedestalsCategory === "SKMD24U0ES" ){
             
                if(document.getElementById('SKCD24U0GS') != null ) document.getElementById('SKCD24U0GS').classList.remove('active');
                if(document.getElementById('Removethepedestal') != null ) document.getElementById('Removethepedestal').classList.remove('active');
                if(document.getElementById('SKMD24U0ES') != null ) document.getElementById('SKMD24U0ES').classList.add('active');
            }

        // }else if(data.id === "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition !== "zoneThree"){
        }else if(data.hotspotId === "underTheCounterPedestalsCategoryhotspotId" && data.productStateSelectContext.pedestalsPosition !== "zoneThree"){
            data.productStateSelectContext.pedestalsPosition = "zoneSeven";
        }else if(data.hotspotId === "underTheCounterPedestalsCategoryhotspotId"){
            data.productStateSelectContext.pedestalsPosition = "zoneSeven";
        }else if(data.hotspotId === "remove_pedestal_zone_7hotspotId"){
            data.productStateSelectContext.pedestalsPosition = "zoneSeven";
        }
        
        if(data.hotspotId === "remove_pedestal_zone_7hotspotId" && data.productStateSelectContext.pedestalsPosition === "zoneSeven"){
            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"
        }

        if(data.hotspotId === "remove_pedestal_zone_3hotspotId"){
            data.productStateSelectContext.pedestalsPosition = "zoneThree";
        }

        // if(data.id == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneThree" 
        // && data.productStateSelectContext.underTheCounterPedestalsCategory == "" && (data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS 
        // && data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES)){
        //     console.log(document.getElementById('Removethepedestal'))
        //   if(document.getElementById('Removethepedestal')) document.getElementById('Removethepedestal').classList.remove('opacityCard');
        // }

        // if(data.id === "underTheCounterPedestalsCategory"){
        //     data.productStateSelectContext.pedestalsPosition = "zoneSeven";
        //     if(document.getElementById('SKCD24U0GS') != null ) document.getElementById('SKCD24U0GS').classList.remove('active');
        //     if(document.getElementById('SKMD24U0ES') != null ) document.getElementById('SKMD24U0ES').classList.add('active');
        // }else if(data.id === "underTheCounterPedestalsCategory" && data.hotspotId != "underTheCounterPedestalsCategoryhotspotId"){
        //     data.productStateSelectContext.pedestalsPosition = "zoneThree";
        // }
        // else if(data.hotspotId === "underTheCounterPedestalsCategoryRighthotspotId"){
        //     data.productStateSelectContext.pedestalsPosition = "zoneThree";
        // }
        // else if(data.hotspotId === "underTheCounterPedestalsCategoryhotspotId"){
        //     data.productStateSelectContext.pedestalsPosition = "zoneSeven";
        // }


        // }else if(data.id === "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition !== "zoneThree"){
        // else if(data.id === "underTheCounterPedestalsCategory"){
        //     data.productStateSelectContext.pedestalsPosition = "zoneSeven";
        // }


            distSingleProduct(data);


        if(data.id == "installWallovenInrightSide" || data.id == "installWalloneOneInright"){
            
            data.productStateSelectContext.wallOvenPosition = "zoneThree";
        }

        let camera = data.camSequence;
        let cameratwo = data.camSequencetwo;
       
        // handleHotspotsVisibility(data,event);
        // console.log("data",data.id);
        // opacityFlag = true;
        // checkForOverLay();

        for(let i=0; i < window.hotspotsList.hslist.length; i++){

        if (data.productStateSelectContext.pedestalsPosition == "zoneThree") {
            if(window.hotspotsList.hslist[i].hsname == "underTheCounterPedestalsCategory-hotspotBtn"){   
        }
        }
        if(data.productStateSelectContext.wallOvenPosition == "zoneThree"){
            if(window.hotspotsList.hslist[i].hsname == "wallOvenCategory-hotspotBtn"){ 
            // window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT_R';
            window.hotspotsList.hslist[i].nameOf3dObj = 'WALL_OVEN_HOTSPOT_R';
            }
        }

    }

        window.scene._bDoF = true;
        event.persist();
        let currentId;
        if(data.id === "underTheCounterPedestalsCategoryRight" || data.id === "remove_pedestal_zone_7" || data.id === "remove_pedestal_zone_3"){
            currentId = "underTheCounterPedestalsCategory";
        }else{
            currentId = data.id;
        }

        //#TPE
        if(data.id === "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition === "zoneSeven"){
            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"
        }
        // console.log("data",data);

        if(data.id == "remove_pedestal_zone_7" && data.productStateSelectContext.pedestalsPosition == "zoneSeven"){
            data.productStateSelectContext[data.id] = "SKCD24U0GS";
        }

        let menuContainer = document.querySelector('.menuAccordion')
        // let currentTarget = document.getElementById(data.id + 'Btn') //
        let currentTarget = document.getElementById(currentId + 'Btn') //

        var popUpproductVisibilitySequence =false;

        let siblingAccordionContent = currentTarget.parentElement.nextElementSibling

        let siblingAccordionContentCSS = window.getComputedStyle(siblingAccordionContent, null);
        

        // var currentActiveProductCallout = document.getElementById( data.productStateSelectContext[data.id] + '-callout')
        // var currentActiveProductHotspot = document.getElementById(data.productStateSelectContext[data.id] + '-hotspot')

        //updated this line to show the hotspot and callouts based on the current category
        var currentActiveProductCallout = document.getElementById( data.productStateSelectContext[currentId] + '-callout')
        var currentActiveProductHotspot = document.getElementById(data.productStateSelectContext[currentId] + '-hotspot')

        let currentTargetIconBtn = document.getElementById(data.id + 'IconBtn');
        var currentTargetIsActive = currentTarget.classList.contains('active');


        if (incomptabilePedestalTwoCheckES !== null) incomptabilePedestalTwoCheckES.classList.remove('opacityCard');
        if (incomptabilePedestalTwoCheckGS !== null) incomptabilePedestalTwoCheckGS.classList.remove('opacityCard')
        if (document.querySelector('#SKMD24U0ES-calloutContainer') != null) {
           if( document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling!=null) document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling.classList.remove('active');// added this condition for removing microwave zommout button
        }
        if (document.querySelector('#SMD2470AS-calloutContainer')) {
            document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling.classList.remove('active'); // added this condition for removing pedestal zommout button
        }

        if(data.id == "underTheCounterPedestalsCategory" && data.productStateSelectContext.currentCam == "walloven_cam" && 
        data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.underTheCounterPedestalsCategory != "" && 
        data.productStateSelectContext.wallOvenCategory != "SWA2450GS" && data.productStateSelectContext.underTheCounterPedestalsCategory != "Remove the pedestal" )
        {
            data.productStateSelectContext.pedestalsPosition = "zoneSeven";
            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
        }

        else if(data.id == "underTheCounterPedestalsCategory" && data.productStateSelectContext.currentCam == "microdrawer_cam"  
        && data.productStateSelectContext.underTheCounterPedestalsCategory != "" && data.productStateSelectContext.wallOvenPosition == "zoneSeven"){ 
            //n data.productStateSelectContext.wallOvenPosition == "zoneSeven"---this line of code has been updated in the above code----as without this line it, was causing error for front side pedestals
            data.productStateSelectContext.pedestalsPosition = "zoneThree";
            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
        }
        else if(data.id == "microwaveDrawerOvensCategory" && data.productStateSelectContext.wallOvenPosition == "zoneSeven"  && data.productStateSelectContext.underTheCounterPedestalsCategory != ""){
            data.productStateSelectContext.pedestalsPosition = "zoneThree";
            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
        }

        //n the condition below is added here so that, whenever we select the pedestal remove button, based on that we can update the other condition's.
         if(data.id == "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition == "zoneSeven" && (
        data.productStateSelectContext.previousId == "underTheCounterPedestalsCategoryhotspotAndCalloutRemove" || data.productStateSelectContext.previousId == "underTheCounterPedestalsCategory"  ) && data.productStateSelectContext.wallOvenPosition == "zoneSeven" 
        && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
            // || data.productStateSelectContext.previousId == "underTheCounterPedestalsCategory" //n-----this line in the above condition is added to cover a possibility issue(for pedestals visibility seq in the front zone)
         data.productStateSelectContext.underTheCounterPedestalsCategory = "";
        }

        //@author - YK
       if(data.productStateSelectContext.currentCam == "walloven_cam" && data.id == "underTheCounterPedestalsCategory"){
            data.productStateSelectContext.pedestalsPosition = "zoneSeven";
        }

        if(data.productStateSelectContext.currentCam == "microdrawer_cam" && data.id == "underTheCounterPedestalsCategory"){
            data.productStateSelectContext.pedestalsPosition = "zoneThree";
        }
        
        // if(data.productStateSelectContext.currentCam == "microdrawer_cam" && data.id == "underTheCounterPedestalsCategoryRight"){
        //     data.productStateSelectContext.pedestalsPosition = "zoneThree";
        // }

        // condition for ES when walloven is not present on the top
        if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" && data.productStateSelectContext.pedestalsPosition == "zoneThree" ){
            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
        }
       
        //this line of code is added to update the zone on accordion click for the pedestals 

        if( data.id == "underTheCounterPedestalsCategory" && data.productStateSelectContext.wallOvenPosition == "zoneThree"){
            data.productStateSelectContext.pedestalsPosition = "zoneThree";
        }


        if(data.productStateSelectContext.pedestalsPosition === "zoneSeven" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS"){
            // document.getElementById('SKCD24U0GS-InstallBelowtheWallOven--btn').style.display = 'none';
            // document.getElementById('SKCD24U0GS-Open-btn').style.display = 'none';
            // document.getElementById('SKCD24U0GS-InstallBelowtheWallOven--btn').style.display = 'none';
            // document.getElementById('SKCD24U0GS-Open-btn').style.display = 'none';
        }

        if(data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" )){
            //  document.getElementById('SKCD24U0GS-Open-btn').style.visibility = 'hidden';
        }
        else if(data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.wallOvenPosition == "zoneThree" ){
           if(document.getElementById('SKCD24U0GS-Open-btn') != null) document.getElementById('SKCD24U0GS-Open-btn').style.visibility = 'visible';
        }

        if (data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.pedestalsPosition == "zoneThree" && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES")) {
            // if (document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden';
        } else if (data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS") {
            // if (document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'visible';
        }

        if (data.productStateSelectContext.wallOvenPosition === "zoneSeven") {
            if (document.getElementById('SSC2489GS-ControlPanel--btn') != null) document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'none';
            if (document.getElementById('SSC2489GS-OpenOven--btn') != null) document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'none';
        } else {
            if (document.getElementById('SSC2489GS-ControlPanel--btn') != null) document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'flex';
            if (document.getElementById('SSC2489GS-OpenOven--btn') != null) document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'flex';
            if (document.getElementById('SSC2489GS-Installunderneaththecounter--btn') != null) document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.display = 'flex';
            if (document.getElementById('SSC2489GS-ControlPanel--btn') != null) document.getElementById('SSC2489GS-ControlPanel--btn').style.visibility = 'visible';
            if (document.getElementById('SSC2489GS-OpenOven--btn') != null) document.getElementById('SSC2489GS-OpenOven--btn').style.visibility = 'visible';
            if (document.getElementById('SSC2489GS-Installunderneaththecounter--btn') != null) document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = 'visible';
        }

        if(document.querySelector('.popUpWidth') != null) document.querySelector('.popUpWidth').style.visibility = "hidden";

        if (data.camSequence != data.productStateSelectContext.currentCam) {
            if(document.querySelector('#internalCalloutsAndHotspots') != null) document.querySelector('#internalCalloutsAndHotspots').style.display = 'block';
            setcalloutInfo(true);
        }

        setproductCategoryHotspot(false);

        let siblingAccordionContentHeight;


       
        // if(data.id != "installWallovenInrightSide"){
            siblingAccordionContentHeight = helperFunc.menuItemHeightCalc(
                siblingAccordionContent.childNodes,
                data
            )
        // }
        //    }
           
        // }
        if (currentTargetIsActive && !nameOf3dObjArray.includes(data.nameOf3dObj)) {

            currentTarget.classList.remove('active')
            siblingAccordionContent.classList.remove('expand')

            currentTargetIconBtn.classList.remove('expand')
            currentTargetIconBtn.classList.remove('active')

            if (currentActiveProductCallout != null) currentActiveProductCallout.classList.remove('active') //callout's remove active
            if (currentActiveProductHotspot != null) currentActiveProductHotspot.classList.remove('active')
            siblingAccordionContentHeight = 0

        }
        else {
            if (document.querySelector('.accordionContentContainer.expand') != null && document.querySelector('.accordionHeading.active') != null) {
                let getOtherActiveAccordion = document.querySelector('.accordionContentContainer.expand')
                let getOtherActiveAccordionBtn = document.querySelector('.accordionHeading.active')
                let getOtherActiveIconBtn = document.querySelector('.iconBtn.active')
                getOtherActiveAccordion.classList.remove('expand');
                getOtherActiveAccordionBtn.classList.remove('active')
                getOtherActiveIconBtn.classList.remove('active')
                getOtherActiveAccordion.style.height = '0px'
            }
            //For current target Accordion
            siblingAccordionContent.classList.add('expand')
            currentTargetIconBtn.classList.add('active')

            currentTarget.classList.add('active')
            


            // if (document.getElementById('productCategoryHotspot') != null) document.getElementById('productCategoryHotspot').style.display = 'none'
            // the above line of code is commented so that the hotspot won't hide on the zoomout click.

            // currentTargetCallout.classList.add('active');//6
            // siblingAccordionContentCallout.classList.add('active');
            if (data.productStateSelectContext.wallOvenPosition === 'zoneSeven') {
                cameraNoResetMatrix['walloven_cam'] = ['cooktop_cam', 'otc_micro_cam', 'OVER_THE_RANGE', 'range_hood_cam', 'WALLOVEN_ZONE3', 'drawer_zone7']
            }
            else if (data.productStateSelectContext.wallOvenPosition === 'zoneThree' || data.id == "installWallovenInrightSide") {
                cameraNoResetMatrix['walloven_cam'] = ['dishwasher_cam', 'drawer_cam', 'reset', 'microdrawer_cam']
            }

            if (data.productStateSelectContext.pedestalsPosition === "zoneSeven") {
                // cameraNoResetMatrix['drawer_zone7'] = ['cooktop_cam','walloven_cam','otc_micro_cam']
                cameraNoResetMatrix['drawer_zone7'] = ['OVER_THE_RANGE', 'range_hood_cam', 'walloven_cam', 'WALLOVEN_ZONE3', 'microdrawer_cam']
            }

            let currentCamNoResetMatrix = cameraNoResetMatrix[data.productStateSelectContext.currentCam];

            if (data.id == 'wallOvenCategory') {
                if (data.productStateSelectContext.wallOvenPosition == "zoneThree") {
                    camera = data.camSequencetwo;
                }
            }
            if (data.id == 'underTheCounterPedestalsCategory') {
                if (data.productStateSelectContext.pedestalsPosition == "zoneThree") {
                    camera = data.camSequencetwo;
                }
            }

            if(data.id == "installWallovenInrightSide" || data.id == "installWalloneOneInright"){
                camera = "WALLOVEN_ZONE3";
            }

             //added this condition to set the camera to the front when user click on the front hotspot
            if(data.productStateSelectContext.underTheCounterPedestalsCategory === "SKMD24U0ES" && data.productStateSelectContext.pedestalsPosition === "" && data.id === "underTheCounterPedestalsCategory"){
             
                camera = "drawer_cam";
                data.productStateSelectContext.pedestalsPosition = "zoneThree";
            }

            if(data.id == "remove_pedestal_zone_3" && data.productStateSelectContext.pedestalsPosition === "zoneThree"){
                camera = "drawer_cam"
            }
            // console.log(currentCamNoResetMatrix,'camMatrix1301')
            if (currentCamNoResetMatrix.indexOf(camera) != -1) {
                camera = camera + '_without_reset';
            }

            // console.log(camera,'1302--------------')
// ------------------------------------------------------------
            //@uthor - YK - Added this code for camera sequence when pedestals is in zone 7 and user click on hotspot
            // if(data.id == 'underTheCounterPedestalsCategory' && data.productStateSelectContext.pedestalsPosition=='zoneThree' && data.productStateSelectContext.currentCam == 'reset'){
            //     window.scene.applySequence(window[camera], function () {

            //         if (window.seqValue == true) {
            //             currentActiveProductHotspot.classList.add('active')
            //             currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                        
            //             document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = 'hidden';
            //             document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.visibility = 'hidden';
            //         }
            //     });
            // }


            if (data.camSequence != ''
                && data.productStateSelectContext.currentCam != data.camSequence
            ) {
              
            window.scene.applySequence(window[camera], function () {
                if (window.seqValue == true) {

                if (data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS" && data.productStateSelectContext.currentCamtwo == "WALLOVEN_ZONE3" ) {
                    if (currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                    if (currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                }else if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS" &&
                data.productStateSelectContext.currentCam == "drawer_zone7" && data.productStateSelectContext.pedestalsPosition != "zoneThree")
                {
                    if (currentActiveProductHotspot != null) currentActiveProductHotspot.classList.remove('active')
                    if (currentActiveProductCallout != null) currentActiveProductCallout.classList.remove('active') //callout added after handleaccordion click
                }
                else{
                    if (currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                    if (currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                }
                }
                //n added this condition to update the pedestalcategory and zone in the front side on walloven click from right side
                    if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.id =="wallOvenCategory" 
                    && data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
                        data.productStateSelectContext.pedestalsPosition = "zoneSeven"; 
                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"; //n this is commented as this was breaking........
                        // the above line of code is uncommented because,Issue occurring for ped Infront, for the hotspot.- is fixed by this
                    }
                    if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"
                    && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS" )
                    && data.productStateSelectContext.pedestalsPosition == "zoneThree"
                    ){
                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
                    }

                    if(data.id === "underTheCounterPedestalsCategory" && data.productStateSelectContext.pedestalsPosition === "zoneThree" && data.productStateSelectContext.underTheCounterPedestalsCategory === "SKCD24U0GS"){
                        
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                        ])
                    }
            })
            
                                 
                data.productStateSelectContext.currentCam = data.camSequence

            if (data.menuItemLength == 1 
                && data?.menuItems[0]?.productVisibilitySequence != 'A1_otcmicro_R1214TY_vis'
                // && data?.menuItems[0]?.productVisibilitySequence != 'A1_refrigerator_SJB1255GS_vis'
                && data?.menuItems[0]?.productVisibilitySequence != 'B1_Drawer_SKCD24U0GS_vis'
                && data?.menuItems[0]?.productVisibilitySequence != 'A1_rangehood_SMO1461GS_vis' // these condition are added here so that, this vis seq,won't overwrite cam_without reset which contains vis seq
                && data?.menuItems[0]?.productVisibilitySequence != 'B1_rangehood_SHC2432FS_vis' // these condition are added here so that, this vis seq,won't overwrite cam_without reset which contains vis seq
                && data?.menuItems[0]?.productVisibilitySequence != 'A1_walloven_SSC2489GS_vis'// distributor code only for the walloven/-
                // && data.productStateSelectContext.currentProductVisibilitySequence == data?.menuItems[0]?.productVisibilitySequence
                && event.target.id != "underTheCounterPedestalsCategorythree" && event.target.value != "zoneThree"
            ) {
                    window.scene.applySequence(
                        window[data?.menuItems[0]?.productVisibilitySequence], function () {
                            if (window.seqValue == true) {
                                if( currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                if( currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                            }
                        }
                    )
            

                    if(data?.menuItems[0]?.productVisibilitySequence === "A1_Drawer_SKMD24U0ES_vis"){
                        data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                    }else if(data?.menuItems[0]?.productVisibilitySequence === "B1_Drawer_SKCD24U0GS_vis"){
                        data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                    }


                // Required - Himanshu
                    if (data.menuItems[0]?.title == 'SMO1461GS') {
                        document.getElementById('overRangeMicroCategory-hotspotBtn').style.visibility = 'visible'
                        document.getElementById('hoodRangeCategory-hotspotBtn').style.visibility = 'hidden'
                    } else if (data.menuItems[0]?.title == 'SHC2432FS') {
                        document.getElementById('overRangeMicroCategory-hotspotBtn').style.visibility = 'hidden'
                        document.getElementById('hoodRangeCategory-hotspotBtn').style.visibility = 'visible'
                    }
                  }
                }
           
                let currentActiveCallout = document.querySelector('.calloutsContainer.active')
                    if (currentActiveCallout != null) {
                        currentActiveCallout.classList.remove('active')
                    }
                    let currentActiveHotspot = document.querySelector('.hotspotContainer.active')
                    if (currentActiveHotspot != null) {
                        currentActiveHotspot.classList.remove('active')
                    }
                //@uthor - YK - Added to show Walloven in Right zone on click of Hotspot

                if(data.id == 'wallOvenCategory' 
                || data.id == "installWallovenInrightSide" || data.id == "installWallovenInFrontSide" 
                || data.id == "installWalloneOneInright" || data.id == "installWallovenOneInFront"){
                    //@uthor - YK - Walloven SSC2489GS
                //    if(data.id == "installWallovenInrightSide"){

                //     //('hotspot click in working in the right side')
                //     data.productStateSelectContext.wallOvenPosition = "zoneThree";
                //     data.productStateSelectContext.pedestalsPosition = "zoneThree";
                //     if(nameOf3dObjArray.includes(data.nameOf3dObj)){
                //         setcalloutInfo(true);
                //     }

                //     if (data.productStateSelectContext.pedestalsPosition == "zoneThree") {
                //         window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_HOTSPOT_01';
                //     }

                //     handleHotspotsVisibility(data,event);

                //    }
                    
                // document.getElementById('installWallovenInrightSideBtn').parentElement.style.display = 'none';

                    if(event.target.id == "SSC2489GS-Installabovethecounter-btn" && data.productStateSelectContext.wallOvenPosition == "zoneSeven" || data.id == "installWallovenInrightSide"){
                        
                        if(data.id == "installWallovenInrightSide"){
                        //   let accordionExpandWalloven = document.getElementById('wallOvenCategoryBtn').classList.add('active');
                          document.getElementById('wallOvenCategoryBtn').classList.add('active');
                          document.querySelector('.accordionContentContainer.wallOvenCategory').classList.add('expand');
                          document.querySelector('.accordionContentContainer.wallOvenCategory').style.height = "221px";
                          document.getElementById('wallOvenCategoryIconBtn').classList.add('active');
                        }
                        
                        data.productStateSelectContext.wallOvenPosition = "zoneThree";
                        data.productStateSelectContext.pedestalsPosition = "zoneThree";
                        if(nameOf3dObjArray.includes(data.nameOf3dObj)){
                            setcalloutInfo(true);
                        }

                        if (data.productStateSelectContext.pedestalsPosition == "zoneThree") {
                            // window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_HOTSPOT_01'; //#TPE
                        }
                  
                        handleHotspotsVisibility(data,event);
                    //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                    if(data.id == "wallOvenCategory" && data.productStateSelectContext.wallOvenPosition == "zoneThree"){
                        data.productStateSelectContext.currentProductVisibilitySequence = data.productStateSelectContext.currentProductVisibilitySequencetwo;
                    }
                    
                        if( event.target.id == "SSC2489GS-Installabovethecounter-btn" ){
                            window.scene.applySequence(window["WALLOVEN_ZONE3"], function(){

                                setTimeout(()=>{
                        
                                    window.scene.applySequence(window["A1_SSC2489GS_Zone3"], function(){
   
                                        if((data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS") && data.productStateSelectContext.underTheCounterPedestalsCategory != "" ){
                                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
                                            data.productStateSelectContext.zoneSevenPedestalRemovedStatus = true
                                        
                                        }else if(data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" && data.productStateSelectContext.underTheCounterPedestalsCategory != "" ){
                                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
                                          
                                        }
    
                                        if (data.productStateSelectContext.microwaveDrawerOvensCategory == "" && data.productStateSelectContext.wallOvenPosition == "zoneThree") {
                                            data.productStateSelectContext.underTheCounterPedestalsCategory = "";
                                            document.getElementById('underTheCounterPedestalsCategoryhotspotAndCalloutRemove').parentElement.classList.remove('active') //n added this line to remove the active on the- 
                                        //underTheCounterPedestalsCategoryhotspotAndCalloutRemove when an product is active
                                        }
    
                                        setTimeout(()=>{
                                            if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                            if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                        },500)
                                       
                                       if(document.getElementById('SSC2489GS-OpenOven--btn') !=null) document.getElementById('SSC2489GS-OpenOven--btn').style.visibility = 'visible';
                                       if(document.getElementById('SSC2489GS-ControlPanel--btn') != null) document.getElementById('SSC2489GS-ControlPanel--btn').style.visibility = 'visible';
                                       if(document.getElementById('SSC2489GS-Installunderneaththecounter--btn') != null) document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = 'visible';
                                       if(document.getElementById('SSC2489GS-ControlPanel--btn') != null) document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'flex';
                                       if(document.getElementById('SSC2489GS-OpenOven--btn') != null) document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'flex';
                                       if(document.getElementById('SSC2489GS-Installunderneaththecounter--btn') != null) document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.display = 'flex';
            
                                    if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" &&
                                    data.productStateSelectContext.pedestalsPosition != "zoneSeven" && data.productStateSelectContext.wallOvenPosition != "zoneSeven" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" )
                                    ){
                                       if(document.getElementById('SKCD24U0GS') != null ) document.getElementById('SKCD24U0GS').classList.add('active');
                                   if(document.querySelector('.Remove.the.pedestal.menuItem')!=null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active') //n added this line to remove the active on remove the pedestal when user install in from the walloven to the right side
                                   
                                   setTimeout(() => {
                                            window.scene.applySequence(window["B1_Drawer_SKCD24U0GS_vis"], function(){
                                                data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                                            });
                                        }, 500);
                                    }else if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS" ) &&
                                    data.productStateSelectContext.pedestalsPosition != "zoneSeven" && data.productStateSelectContext.wallOvenPosition != "zoneSeven" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" )
                                    ){
                                 
                                        if(document.getElementById('SKMD24U0ES') != null) document.getElementById('SKMD24U0ES').classList.add('active');
                                          
                                            setTimeout(() => {
                                                data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                                                window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"], function(){
                                                });
                                            }, 500);
                                    }
            
                                    setTimeout(()=>{
                                        if(data.id == "installWallovenInrightSide"){
                                            if(document.getElementById('SSC2489GS-hotspot') ) document.getElementById('SSC2489GS-hotspot').classList.add('active');
                                            if(document.getElementById('SSC2489GS-callout')) document.getElementById('SSC2489GS-callout').classList.add('active');
                                            
                                        }
                                    },1000) 
                                });
                              },100)
                            })
                        }
                      
                        if(data.id == "installWallovenInrightSide"){
                       
                            setTimeout(()=>{
                             
                                window.scene.applySequence(window["A1_SSC2489GS_Zone3"], function(){
                                    if((data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS") && data.productStateSelectContext.underTheCounterPedestalsCategory != "" ){
                              
                                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
                                        data.productStateSelectContext.zoneSevenPedestalRemovedStatus = true
                                        data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                                    }else if(data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" && data.productStateSelectContext.underTheCounterPedestalsCategory != "" ){
                                    
                                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
                                    }
                                    if (data.productStateSelectContext.microwaveDrawerOvensCategory == "" && data.productStateSelectContext.wallOvenPosition == "zoneThree") {
                                        data.productStateSelectContext.underTheCounterPedestalsCategory = "";
                                        data.productStateSelectContext.zoneSevenPedestalRemovedStatus = true
                                        data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = true;
                                        data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = true;
                                     
                                        if(document.getElementById('underTheCounterPedestalsCategoryhotspotAndCalloutRemove')){
                                            document.getElementById('underTheCounterPedestalsCategoryhotspotAndCalloutRemove').parentElement.classList.remove('active') //n added this line to remove the active on the- 
                                        }
                                        //underTheCounterPedestalsCategoryhotspotAndCalloutRemove when an product is active
                                    }
                                    setTimeout(()=>{
                                        if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                        if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                    },500)
                                   
                                   if(document.getElementById('SSC2489GS-OpenOven--btn') !=null) document.getElementById('SSC2489GS-OpenOven--btn').style.visibility = 'visible';
                                   if(document.getElementById('SSC2489GS-ControlPanel--btn') != null) document.getElementById('SSC2489GS-ControlPanel--btn').style.visibility = 'visible';
                                   if(document.getElementById('SSC2489GS-Installunderneaththecounter--btn') != null) document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = 'visible';
        
                                   if(document.getElementById('SSC2489GS-ControlPanel--btn') != null) document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'flex';
                                   if(document.getElementById('SSC2489GS-OpenOven--btn') != null) document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'flex';
                                   if(document.getElementById('SSC2489GS-Installunderneaththecounter--btn') != null) document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.display = 'flex';
        
                                    if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" &&
                                data.productStateSelectContext.pedestalsPosition != "zoneSeven" && data.productStateSelectContext.wallOvenPosition != "zoneSeven" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" )
                                ){
                                   if(document.getElementById('SKCD24U0GS') != null ) document.getElementById('SKCD24U0GS').classList.add('active');
                                document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active') //n added this line to remove the active on remove the pedestal when user install in from the walloven to the right side
                                    setTimeout(() => {
                                        window.scene.applySequence(window["B1_Drawer_SKCD24U0GS_vis"], function(){
                                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                                        });
                                    }, 500);    
                                }else if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS" ) &&
                                data.productStateSelectContext.pedestalsPosition != "zoneSeven" && data.productStateSelectContext.wallOvenPosition != "zoneSeven" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" )
                                ){
                                  
                                    if(document.getElementById('SKMD24U0ES') != null) document.getElementById('SKMD24U0ES').classList.add('active');
                                
                                        setTimeout(() => {
                                            window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"], function(){
                                                data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;

                                            });
                                        }, 500);
                                }
        
                                setTimeout(()=>{
                                    if(data.id == "installWallovenInrightSide"){
                                        if(document.getElementById('SSC2489GS-callout')) document.getElementById('SSC2489GS-callout').classList.add('active');
                                        if(document.getElementById('SSC2489GS-hotspot')) document.getElementById('SSC2489GS-hotspot').classList.add('active');
                                    }
                                },1000)
                                
                                });

                            },3000) //from 6000 sec to 3000 sec
                            
                        }
                        //n this code is implemented to move the pedestal to right side after removing it and go to the walloven 
                    }

                    if(event.target.id == "SSC2489GS-Installunderneaththecounter--btn" && data.productStateSelectContext.wallOvenPosition == "zoneThree" 
                    || data.id == "installWallovenInFrontSide"){
                       
                        // the hotspot present below are added, so that on the direct call of this condition, these will get hide and doesn't take time.
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                            { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        ])
                        

                        if(data.id == "installWallovenInFrontSide"){
                            if(document.getElementById('wallOvenCategoryBtn')) document.getElementById('wallOvenCategoryBtn').classList.add('active');
                            if(document.querySelector('.accordionContentContainer.wallOvenCategory')) document.querySelector('.accordionContentContainer.wallOvenCategory').classList.add('expand');
                            if(document.querySelector('.accordionContentContainer.wallOvenCategory')) document.querySelector('.accordionContentContainer.wallOvenCategory').style.height = "221px";
                            if(document.getElementById('wallOvenCategoryIconBtn')) document.getElementById('wallOvenCategoryIconBtn').classList.add('active');
                        }

                        if(nameOf3dObjArray.includes(data.nameOf3dObj)){
                            setcalloutInfo(true);
                        }
                        
                       if(event.target.id == "SSC2489GS-Installunderneaththecounter--btn"){
                        window.scene.applySequence(window["A1_walloven_SSC2489GS_vis"], function(){
                            data.productStateSelectContext.wallOvenPosition = "zoneSeven";
                            data.productStateSelectContext.pedestalsPosition = "zoneSeven";
                  
                            handleHotspotsVisibility(data,event);
                            // data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";

                            if(event.target.id == "SSC2489GS-Installunderneaththecounter--btn"){
                                currentActiveProductHotspot.classList.add('active')
                                currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click     // these line are commented cause it was causing issue
                            }
                          
                            document.getElementById('SSC2489GS-OpenOven--btn').style.visibility = 'hidden';
                            document.getElementById('SSC2489GS-ControlPanel--btn').style.visibility = 'hidden';
                            document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = 'hidden';
                            
                            document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'none';
                            document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'none';
                            document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.display = 'none';

                            //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                            data.productStateSelectContext.currentProductVisibilitySequence = 'A1_walloven_SSC2489GS_vis';

                            setTimeout(()=>{
                                if(data.id == "installWallovenInFrontSide"){
                                    document.getElementById('SSC2489GS-hotspot').classList.add('active');
                                    document.getElementById('SSC2489GS-callout').classList.add('active');
                                }
                            },1000)
                        });
                       }

                        if(data.id == "installWallovenInFrontSide"){
                            window.scene.applySequence(window["walloven_cam"], function(){
                                setTimeout(()=>{
                                    // window.scene.applySequence(window["A1_walloven_SSC2489GS_vis"], function(){

                                    window.scene.applySequence(window["A1_walloven_SSC2489GS_vis"]);
                                      // the callback is removed here cause it was causing an issue here/-
                                        data.productStateSelectContext.wallOvenPosition = "zoneSeven";
                                        data.productStateSelectContext.pedestalsPosition = "zoneSeven";
                                
                                        handleHotspotsVisibility(data,event);
                                        // data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
            
                                        if(event.target.id == "SSC2489GS-Installunderneaththecounter--btn"){
                                            currentActiveProductHotspot.classList.add('active')
                                            currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click     // these line are commented cause it was causing issue
                                        }
                                      
                                        document.getElementById('SSC2489GS-OpenOven--btn').style.visibility = 'hidden';
                                        document.getElementById('SSC2489GS-ControlPanel--btn').style.visibility = 'hidden';
                                        document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = 'hidden';
                                        
                                        document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'none';
                                        document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'none';
                                        document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.display = 'none';
            
                                        //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                                        data.productStateSelectContext.currentProductVisibilitySequence = 'A1_walloven_SSC2489GS_vis';
            
                                        setTimeout(()=>{
                                            if(data.id == "installWallovenInFrontSide"){
                                                document.getElementById('SSC2489GS-hotspot').classList.add('active');
                                                document.getElementById('SSC2489GS-callout').classList.add('active');
                                            }
                                        },1000)
                                },100)
                        })
                        }

                        data.productStateSelectContext.underTheCounterPedestalsCategory = "" //n added this due to pedestal visibility wasn't working!

//                         if (data.id == "microwaveDrawerOvensCategory") {
//                             if (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" && data.productStateSelectContext.wallOvenPosition == "zoneSeven") {
//  ---------------------------------------------- 
//                             if (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS") {
//                                 setTimeout(() => {
//                                     window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_B_vis']);
//                                 }, 3500)
//                             }
                    }

                    //@uthor - YK - Walloven SWA2450GS
                    if(event.target.id == "SWA2450GS-Installabovethecounter-btn" && data.productStateSelectContext.wallOvenPosition == "zoneSeven" || data.id == "installWalloneOneInright"){

                        if(data.id == "installWalloneOneInright"){
                        document.getElementById('wallOvenCategoryBtn').classList.add('active');
                        document.querySelector('.accordionContentContainer.wallOvenCategory').classList.add('expand');
                        document.querySelector('.accordionContentContainer.wallOvenCategory').style.height = "221px";
                        document.getElementById('wallOvenCategoryIconBtn').classList.add('active');
                        }

                        if(nameOf3dObjArray.includes(data.nameOf3dObj)){
                            setcalloutInfo(true);
                        }
                       
                        if(event.target.id == "SWA2450GS-Installabovethecounter-btn"){

                            // document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling.style.display = "none"
                            // let pedremoveActive =document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling;
                            // pedremoveActive.classList.remove('active');

                            window.scene.applySequence(window["WALLOVEN_ZONE3"], function(){

                                setTimeout(()=>{
                                   
                                    window.scene.applySequence(window["B1_SWA2450GS_AST_Zone3"], function(){
                                        data.productStateSelectContext.wallOvenPosition = "zoneThree";
                                        data.productStateSelectContext.pedestalsPosition = "zoneThree";
                                        // window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_HOTSPOT_01'; #TPE
                                    
                                        handleHotspotsVisibility(data,event);

                                        
                                        document.getElementById('SKCD24U0GS').classList.add('opacityCard');
                                  
                                        window.hotspotsList.setHotspotsActive([
                                            { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true }
                                        ])
                                       //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                                        if(data.id == "wallOvenCategory" && data.productStateSelectContext.wallOvenPosition == "zoneThree"){
                                            data.productStateSelectContext.currentProductVisibilitySequence = data.productStateSelectContext.currentProductVisibilitySequencetwo;
                                        }
    
                                        if(event.target.id == "SWA2450GS-Installabovethecounter-btn"){
                                            currentActiveProductHotspot.classList.add('active')
                                            currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                        }
                                        
                                        document.getElementById('SWA2450GS-OpenOven--btn').style.visibility = 'visible';
                                        document.getElementById('SWA2450GS-ControlPanel--btn').style.visibility = 'visible';
                                        document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.visibility = 'visible';
            
                                        document.getElementById('SWA2450GS-OpenOven--btn').style.display = 'flex';
                                        document.getElementById('SWA2450GS-ControlPanel--btn').style.display = 'flex';
                                        document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.display = 'flex';
                                        
                                        if(data.productStateSelectContext.wallOvenCategory == "SWA2450GS" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" && data.productStateSelectContext.wallOvenPosition == "zoneThree")
                                        {      
                                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";     
                                        } 
            
                                        setTimeout(()=>{
                                            if(data.id == "installWalloneOneInright"){
                                                document.getElementById('SWA2450GS-callout').classList.add('active');
                                                document.getElementById('SWA2450GS-hotspot').classList.add('active');
                                            }
                                        },1000)
                                        
            
            
                                        if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" &&
                                        data.productStateSelectContext.pedestalsPosition != "zoneSeven" && data.productStateSelectContext.wallOvenPosition != "zoneSeven" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" 
                                        || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES")
                                        ){
                                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
                                           if(document.getElementById('SKCD24U0GS')!=null) document.getElementById('SKCD24U0GS').classList.add('active');
                                            setTimeout(() => {
                                                window.scene.applySequence(window["B1_Drawer_SKCD24U0GS_vis"], function(){
                                                    data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                                                });
                                            }, 500);
                                               
                                      
                                        }else if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS" ) &&
                                        data.productStateSelectContext.pedestalsPosition != "zoneSeven" && data.productStateSelectContext.wallOvenPosition != "zoneSeven" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" ||  data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal")
                                        ){
                                           
                                                document.getElementById('SKMD24U0ES').classList.add('active');
                                          
                                                setTimeout(() => {
                                                    window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"], function(){
                                                        data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                                                    });
                                                }, 500);
                                        }
                                    });
                                },100)
                            })
                        }

                       if(data.id == "installWalloneOneInright"){
                        setTimeout(()=>{
                            window.scene.applySequence(window["B1_SWA2450GS_AST_Zone3"], function(){
                                data.productStateSelectContext.wallOvenPosition = "zoneThree";
                                data.productStateSelectContext.pedestalsPosition = "zoneThree";
                                // window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_HOTSPOT_01'; #TPE
                              
                                handleHotspotsVisibility(data,event);
                               //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                                if(data.id == "wallOvenCategory" && data.productStateSelectContext.wallOvenPosition == "zoneThree"){
                                    data.productStateSelectContext.currentProductVisibilitySequence = data.productStateSelectContext.currentProductVisibilitySequencetwo;
                                }
                                if(event.target.id == "SWA2450GS-Installabovethecounter-btn"){
                                    currentActiveProductHotspot.classList.add('active')
                                    currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                }
                                document.getElementById('SWA2450GS-OpenOven--btn').style.visibility = 'visible';
                                document.getElementById('SWA2450GS-ControlPanel--btn').style.visibility = 'visible';
                                document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.visibility = 'visible';
    
                                document.getElementById('SWA2450GS-OpenOven--btn').style.display = 'flex';
                                document.getElementById('SWA2450GS-ControlPanel--btn').style.display = 'flex';
                                document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.display = 'flex';
                                
                                if(data.productStateSelectContext.wallOvenCategory == "SWA2450GS" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" && data.productStateSelectContext.wallOvenPosition == "zoneThree")
                                {   
                                    data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";     
                                } 
    
                                setTimeout(()=>{
                                    if(data.id == "installWalloneOneInright"){
                                        if(document.getElementById('SWA2450GS-callout')){
                                            document.getElementById('SWA2450GS-callout').classList.add('active');
                                        }
                                        if(document.getElementById('SWA2450GS-hotspot')){
                                            document.getElementById('SWA2450GS-hotspot').classList.add('active');
                                        }
                                    }
                                },1000)
                                
                                if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" &&
                                data.productStateSelectContext.pedestalsPosition != "zoneSeven" && data.productStateSelectContext.wallOvenPosition != "zoneSeven" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" 
                                || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES")
                                ){
                                    data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
                                    if(document.getElementById('SKCD24U0GS')){
                                        document.getElementById('SKCD24U0GS').classList.add('active');
                                    }
                                    setTimeout(() => {
                                        window.scene.applySequence(window["B1_Drawer_SKCD24U0GS_vis"], function(){
                                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                                        });
                                    }, 500);
                                       
                                }else if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS" ) &&
                                data.productStateSelectContext.pedestalsPosition != "zoneSeven" && data.productStateSelectContext.wallOvenPosition != "zoneSeven" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" ||  data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal")
                                ){
                                        if(document.getElementById('SKMD24U0ES')){
                                            document.getElementById('SKMD24U0ES').classList.add('active');
                                        }
                                      
                                        setTimeout(() => {
                                            window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"], function(){
                                                data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                                            });
                                        }, 500);
                                }
                            });
                        },3000)  // from 4sec to 3sec 
                       }
                    }

                    if(event.target.id == "SWA2450GS-Installunderneaththecounter--btn" && data.productStateSelectContext.wallOvenPosition == "zoneThree" || data.id == "installWallovenOneInFront"){
                        // //('1378');
                        // the hotspot present below are added, so that on the direct call of this condition, these will get hide and doesn't take time.
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                            { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                        ])
        
                        if(data.id == "installWallovenOneInFront"){

                            if(document.getElementById('wallOvenCategoryBtn')){
                                document.getElementById('wallOvenCategoryBtn').classList.add('active');
                            }
                            if(document.querySelector('.accordionContentContainer.wallOvenCategory')){
                                document.querySelector('.accordionContentContainer.wallOvenCategory').classList.add('expand');
                            }
                            
                            if(document.querySelector('.accordionContentContainer.wallOvenCategory')){
                                document.querySelector('.accordionContentContainer.wallOvenCategory').style.height = "221px";
                            }
                            
                            if(document.getElementById('wallOvenCategoryIconBtn')){
                                document.getElementById('wallOvenCategoryIconBtn').classList.add('active');
                            }
                            

                            }
                       
                        if(nameOf3dObjArray.includes(data.nameOf3dObj)){
                            setcalloutInfo(true);
                        }
                        data.productStateSelectContext.underTheCounterPedestalsCategory = ""; //n pedestal is remove in this case

                        if(event.target.id == "SWA2450GS-Installunderneaththecounter--btn"){
                            window.scene.applySequence(window["B1_microdrawer_SWA2450GS_vis"], function(){
                                data.productStateSelectContext.wallOvenPosition = "zoneSeven";
                          
                                handleHotspotsVisibility(data,event);
                                
                                if(event.target.id == "SWA2450GS-Installunderneaththecounter--btn"){
                                    currentActiveProductHotspot.classList.add('active')
                                    currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                }
                              
    
                                if(document.getElementById('SWA2450GS-OpenOven--btn')){
                                    document.getElementById('SWA2450GS-OpenOven--btn').style.visibility = 'hidden';
                                }

                                if(document.getElementById('SWA2450GS-ControlPanel--btn')){
                                    document.getElementById('SWA2450GS-ControlPanel--btn').style.visibility = 'hidden';
                                }

                                if(document.getElementById('SWA2450GS-Installunderneaththecounter--btn')){
                                    document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.visibility = 'hidden';
                                }

                                if(document.getElementById('SWA2450GS-OpenOven--btn')){
                                    document.getElementById('SWA2450GS-OpenOven--btn').style.display = 'none';
                                }
    
                                if(document.getElementById('SWA2450GS-ControlPanel--btn')){
                                    document.getElementById('SWA2450GS-ControlPanel--btn').style.display = 'none';
                                }

                                if(document.getElementById('SWA2450GS-Installunderneaththecounter--btn')){
                                    document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.display = 'none';
                                }
    
                                // data.productStateSelectContext.pedestalsPosition = "";
                                // data.productStateSelectContext.underTheCounterPedestalsCategory = "";
                                // window.scene.applySequence(window["LZ3_pedestal_vis_on"])
                                 //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                                 data.productStateSelectContext.currentProductVisibilitySequence = 'B1_microdrawer_SWA2450GS_vis';
    
                                 if(data.id == "installWallovenOneInFront"){
                                    if(document.getElementById('SWA2450GS-callout')){
                                        document.getElementById('SWA2450GS-callout').classList.add('active');
                                    }

                                    if(document.getElementById('SWA2450GS-hotspot')){
                                        document.getElementById('SWA2450GS-hotspot').classList.add('active');
                                    }
                                }
                            });
                        }
                        
                        if(data.id == "installWallovenOneInFront"){
                            window.scene.applySequence(window["walloven_cam"], function(){
                                setTimeout(()=>{
                                    // window.scene.applySequence(window["B1_microdrawer_SWA2450GS_vis"], function(){
                                    window.scene.applySequence(window["B1_microdrawer_SWA2450GS_vis"]);
                                    
                                        data.productStateSelectContext.wallOvenPosition = "zoneSeven";
                                       
                                        handleHotspotsVisibility(data,event);
                                        if(event.target.id == "SWA2450GS-Installunderneaththecounter--btn"){
                                            currentActiveProductHotspot.classList.add('active')
                                            currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                        }
            
                                        document.getElementById('SWA2450GS-OpenOven--btn').style.visibility = 'hidden';
                                        document.getElementById('SWA2450GS-ControlPanel--btn').style.visibility = 'hidden';
                                        document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.visibility = 'hidden';
                                        document.getElementById('SWA2450GS-OpenOven--btn').style.display = 'none';
                                        document.getElementById('SWA2450GS-ControlPanel--btn').style.display = 'none';
                                        document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.display = 'none';
            
                                         //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                                         data.productStateSelectContext.currentProductVisibilitySequence = 'B1_microdrawer_SWA2450GS_vis';
            
                                         if(data.id == "installWallovenOneInFront"){
                                            document.getElementById('SWA2450GS-callout').classList.add('active');
                                            document.getElementById('SWA2450GS-hotspot').classList.add('active');
                                        }
                                    // });
                                },100)
                            })
                        }
                        // window.scene.applySequence(window["walloven_cam"], function(){
// --------------------------------------------------------
                        // if (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS") {
                        //     setTimeout(() => {
                        //         window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_B_vis']);
                        //     }, 3500)
                        // }
                    }
                    
                    if(data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                         if( document.getElementById('SSC2489GS-Installunderneaththecounter--btn') != null)  document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = "hidden";
                         if(document.getElementById('SWA2450GS-Installunderneaththecounter--btn') != null)  document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.visibility = "hidden";
                         if(document.getElementById('SWA2450GS-OpenOven--btn') != null)  document.getElementById('SWA2450GS-OpenOven--btn').style.visibility = "hidden";
                         if(document.getElementById('SWA2450GS-ControlPanel--btn') != null)  document.getElementById('SWA2450GS-ControlPanel--btn').style.visibility = "hidden";
                    }
                }

                //@uthor - YK - Added to for  Pedestals 
                if(data.id == 'underTheCounterPedestalsCategory'){
                    document.querySelector('.Remove.the.pedestal-callout') && document.querySelector('.Remove.the.pedestal-callout').classList.remove('active') //n added this to remove the pedestal callout on every click
                    //@uthor - YK - Pedestals SKCD24U0GS Move to Front zone on accordion expand
                    if(event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" &&
                        data.productStateSelectContext.pedestalsPosition == "zoneSeven" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS"
                         && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.currentCamtwo != "reset" && data.productStateSelectContext.currentCam != "drawer_zone7"
                        //   && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS"

                    ){
                 
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                        ]);

                        window.scene.applySequence(window["SKCD24U0GS_zone7_on"], function(){
                            if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                            if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                           if(document.getElementById('SKCD24U0GS-Open--btn') != null) document.getElementById('SKCD24U0GS-Open--btn').style.display = 'flex';
                           if(document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn') != null) document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn').style.display = 'flex';
                           data.productStateSelectContext.previousId =  "underTheCounterPedestalsCategory"; //n
                           data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                        }); // Only sequence called as Hotspot and callout already working 
                    }
                  
                    //@uthor - YK - Pedestals SKCD24U0GS Move to Right Zone
                    
                    if(event.target.id == "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && data.productStateSelectContext.pedestalsPosition == "zoneSeven"){        
                        //@SH15APR24CF - changes for removing the active from the Microwave Drawer accordian Click
                        //Changes// - Active the microwaveDrawerOvensCategory-hotspotBtn for move Front to Right Zone
                            if(data.productStateSelectContext.microwaveDrawerOvensCategory === "SMD2440JS"){
                                document.querySelector(".SMD2440JS.menuItem").classList.remove("active");
                                document.querySelector("#microwaveDrawerOvensCategory-hotspotBtn").style.visibility = "visible";
                            }else if(data.productStateSelectContext.microwaveDrawerOvensCategory === "SMD2479JS"){
                                document.querySelector(".SMD2479JS.menuItem").classList.remove("active");
                                document.querySelector("#microwaveDrawerOvensCategory-hotspotBtn").style.visibility = "visible";
                                }else if(data.productStateSelectContext.microwaveDrawerOvensCategory === "SMD2470AS"){
                                    document.querySelector(".SMD2470AS.menuItem").classList.remove("active");
                                    document.querySelector("#microwaveDrawerOvensCategory-hotspotBtn").style.visibility = "visible"; 
                                }else if(document.querySelector(".Remove.the.microwave.drawer.menuItem")){
                                document.querySelector(".Remove.the.microwave.drawer.menuItem").classList.remove("active");
                                document.querySelector("#microwaveDrawerOvensCategory-hotspotBtn").style.visibility = "visible";
                                }
                                setTimeout(() => {
                                window.hotspotsList.setHotspotsActive([
                                    { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                                ])
                            
                            }, 2000);

                      window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                    ])
                        data.productStateSelectContext.pedestalsPosition = "zoneThree"; //n added this to move the pedestal to right side on the click on hotspot in front side
                        data.productStateSelectContext.wallOvenPosition = "zoneThree"; //n added this to move the pedestal to right side on the click on hotspot in front side
                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"; //n added this to move the pedestal to right side on the click on hotspot in front side
                        data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2499FS";
                    

                        if(pedestalHotspot.includes(data.nameOf3dObj)){
                            setcalloutInfo(true);
                           }
                         
                           handleHotspotsVisibility(data,event);
                        if (data.productStateSelectContext.wallOvenPosition == "zoneThree") {
                            window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT_R'

                        }
                        //    data.productStateSelectContext.opacityFlag = true;
                        //    if(data.productStateSelectContext.opacityFlag == true){
                        //     //("true flag opacity")
                        //     document.getElementById('overLay').style.display='block';
                        //    }

                        // added this code to remove the active when user moves the pedestal to the right side from the front side by hotspot click
                        if(document.getElementById('SMD2470AH')) document.getElementById('SMD2470AH').classList.remove('active')
                        //n added this conditon to avoid the camera intersection while clicking on front hotspot o walloven when it is opened!
                    
                        window.scene.applySequence(window["drawer_cam"],function(){
                            setTimeout(() => {
                                window.scene.applySequence(window["B1_Drawer_SKCD24U0GS_vis"], function(){
                                    setTimeout(function(){
                                        window.scene.applySequence(window["A1_microdrawer_SMD2499FS_vis"], function(){
                                            data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2499FS";
                                            data.productStateSelectContext.zoneSevenPedestalRemovedStatus = true;
                                            // data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                                            // data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = true;
                                            setTimeout(function(){
                                
                                                window.scene.applySequence(window["A1_SSC2489GS_Zone3"], function(){
                                                    data.productStateSelectContext.wallOvenPosition = "zoneThree";
                                                    if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                                    if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                                    if(document.querySelector('.SMD2489ES.menuItem')!=null) document.querySelector('.SMD2489ES.menuItem').classList.remove('active');
                                                    if(document.querySelector('.SMD2499FS.menuItem')!=null) document.querySelector('.SMD2499FS.menuItem').classList.add('active');
                                                    document.getElementById('SKCD24U0GS-Open-btn').style.display = 'flex';
                                                    document.getElementById('SKCD24U0GS-InstallBelowtheWallOven--btn').style.display = 'flex';
                                                    //n activated the hotspot and callout when user go to walloven right then front then pedestal hotspot to install in the right 
                                                    document.getElementById('SKCD24U0GS-hotspot').classList.add('active')
                                                    document.getElementById('SKCD24U0GS-callout').classList.add('active')


                                                    // data.productStateSelectContext.opacityFlag = false;
                                                    // if(data.productStateSelectContext.opacityFlag == false){
                                                    //     //('false flag opacity')
                                                    //     document.getElementById('overLay').style.display='none';
                                                    // }

                                                });
                                                // },200);
                                            },1200);
                                        });
                                    },100);
                                });
                                
                            }, 100);

                        })

                    }
                    //@uthor - YK - Pedestals SKCD24U0GS Move to Front Zone
                    if(event.target.id == "SKCD24U0GS-InstallBelowtheWallOven--btn" && data.productStateSelectContext.pedestalsPosition == "zoneThree"){
                        if(pedestalHotspot.includes(data.nameOf3dObj)){
                            setcalloutInfo(true);
                           }
                           window.hotspotsList.setHotspotsActive([
                            { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                        ]);
                        window.scene.applySequence(window["SKCD24U0GS_zone7_on"], function(){
                            data.productStateSelectContext.pedestalsPosition = "zoneSeven";
                            data.productStateSelectContext.wallOvenCategory = "SSC2489GS"; //n added this condition to update the callout and visibilty of correct wall oven
                            if(document.getElementById('SWA2450GS')!=null) document.getElementById('SWA2450GS').classList.remove('active'); //n added this condition to update the callout and visibilty of correct wall oven
                            if(document.getElementById('SSC2489GS')!=null) document.getElementById('SSC2489GS').classList.add('active'); //n added this condition to update the callout and visibilty of correct wall oven
                            data.productStateSelectContext.previousId =  "underTheCounterPedestalsCategory"; //n
                            data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                            // handleHotspotsVisibility(data,event);
                          
                            setTimeout(function(){
                                // window.scene.applySequence(window["A1_microdrawer_SMD2499FS_vis"], function(){
                                //     data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2499FS";
                                    setTimeout(function(){
                                        window.scene.applySequence(window["A1_walloven_SSC2489GS_vis"], function(){
                                            data.productStateSelectContext.wallOvenPosition = "zoneSeven";
                                            
                                            handleHotspotsVisibility(data,event); //
                                            if(data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                                                window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT'
                                            }
                                            if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                            if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click

                                            if(document.getElementById('SKCD24U0GS-Open--btn')){
                                                document.getElementById('SKCD24U0GS-Open--btn').style.display = 'flex';
                                            }

                                            if(document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn')){
                                                document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn').style.display = 'flex';
                                            }

                                            if(document.getElementById('SKCD24U0GS-hotspot')){
                                                document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                                            }

                                            setTimeout(() => {
                                                window.scene.applySequence(window["drawerwall_zone7_off"])
                                            }, 50);
                                        });
                                    },100)
                                },1000); //n this was added on 23-may 
                            // },100)
                        });
                    }

                    if( event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" && 
                    data.productStateSelectContext.pedestalsPosition == "zoneThree" && (data.productStateSelectContext.currentCam == "microdrawer_cam" || data.productStateSelectContext.currentCam == "drawer_zone7" || data.productStateSelectContext.currentCamtwo == "drawer_cam") && 
                    data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS")){
                        // data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";

                        setTimeout(function(){
                       
                            window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"]);
                            if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                            if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                            if(document.getElementById('SKMD24U0ES-callout') != null) document.getElementById('SKMD24U0ES-callout').classList.add('active');
                            if(document.getElementById('SKMD24U0ES-hotspot') != null) document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                            // if(document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden';
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                        },2500)
                    }
                 
                    // we have added this condition here so that,whenever the pedestals is off and user goes to another product and came back the pedestals should be on!
                    if(data.productStateSelectContext.pedestalsPosition == "zoneThree" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal" || data.productStateSelectContext.underTheCounterPedestalsCategory == "" ) &&
                     (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" )
                     && (pedestalVisCam.includes(data.productStateSelectContext.previousCam)) && data.productStateSelectContext.pedestalsPosition != "zoneSeven"
                    //  && (pedestalVisCam.includes(data.productStateSelectContext.previousCam) || pedestalVisCamTwo.includes(data.camSequencetwo))
                     ){
                        if(data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS"){

                            if(pedestalIntersectCams.includes(data.productStateSelectContext.previousCam)){
                             
                                setTimeout(function(){
                                    window.scene.applySequence(window["drawer_cam"],()=>{
                                        setTimeout(function(){
                                        
                                            window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"]);
                                            if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                            if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                           if(document.getElementById('SKMD24U0ES-callout') != null) document.getElementById('SKMD24U0ES-callout').classList.add('active');
                                           if(document.getElementById('SKMD24U0ES-hotspot') != null) document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                                            // if(document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden';
                                            if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active')
                                            if(document.getElementById('SKCD24U0GS') != null) document.getElementById('SKCD24U0GS').classList.add('opacityCard');
                                            if(document.getElementById('SKMD24U0ES') != null) document.getElementById('SKMD24U0ES').classList.add('active');
                                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                                        },1000)
                                    });
                                },200)
                            }else{
                               
                                setTimeout(function(){
                                     
                                    window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"]);
                                    if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                    if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                    if(document.getElementById('SKMD24U0ES-callout') != null) document.getElementById('SKMD24U0ES-callout').classList.add('active');
                                    if(document.getElementById('SKMD24U0ES-hotspot') != null) document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                                    // if(document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden';
                                                    
                                    if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active')
                                    if(document.getElementById('SKCD24U0GS') != null) document.getElementById('SKCD24U0GS').classList.add('opacityCard');
                                    if(document.getElementById('SKMD24U0ES') != null) document.getElementById('SKMD24U0ES').classList.add('active');
                                    data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                                    data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
                                },200)
                            }
                        }else if(data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" 
                        && data.productStateSelectContext.wallOvenPosition == "zoneThree" //n added this condition to remove to possiblity of GS pedestal installation when the walloven isn't present
                        ){
                            if(pedestalIntersectCams.includes(data.productStateSelectContext.previousCam)){
                             
                                setTimeout(function(){
                                    window.scene.applySequence(window["drawer_cam"],()=>{
                                        setTimeout(function(){
                                            window.scene.applySequence(window["B1_Drawer_SKCD24U0GS_vis"]);
                                            if(document.getElementById('SKCD24U0GS-callout') != null) document.getElementById('SKCD24U0GS-callout').classList.add('active');
                                            if(document.getElementById('SKCD24U0GS-hotspot') != null) document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                                            if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active')
                                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                                        },1000)
                                    });
                                },200)
                            }
                            else if(event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn"){
                                //n the condition above is added so added so that whenever user click on hotspot,the code present below shouldn't execute for ped in right 
                                setTimeout(function(){
                                    window.scene.applySequence(window["B1_Drawer_SKCD24U0GS_vis"]);
                                    if(document.getElementById('SKCD24U0GS-callout') != null) document.getElementById('SKCD24U0GS-callout').classList.add('active');
                                    if(document.getElementById('SKCD24U0GS-hotspot') != null) document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                                    if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active')
                                    data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                                },200)
                            }

                        }
                        else if(data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" 
                        && data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                            
                                window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_B_vis"]);
                                if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                if(document.getElementById('SKMD24U0ES-callout') != null) document.getElementById('SKMD24U0ES-callout').classList.add('active');
                                if(document.getElementById('SKMD24U0ES-hotspot') != null) document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                                if(document.getElementById('SKMD24U0ES-Open-btn') != null) document.getElementById('SKMD24U0ES-Open-btn').style.visibility = 'hidden';
                        }
                       
                    }

                    // if( event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" && 
                    // data.productStateSelectContext.pedestalsPosition == "zoneThree" && (data.productStateSelectContext.currentCam == "drawer_zone7" || data.productStateSelectContext.currentCamtwo == "drawer_cam") && 
                    // data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal" && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS")){
                    //     // data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
                    //     setTimeout(function(){
                    //         window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"]);
                    //         if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                    //         if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click

                    //         document.getElementById('SKMD24U0ES-callout').classList.add('active');
                    //         document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                    //         document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden';

                    //     },200)
                    // }

                    if(data.productStateSelectContext.pedestalsPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory != "SWA2450GS" 
                    && (data.productStateSelectContext.underTheCounterPedestalsCategory == "" || data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal")){
                        if(document.querySelector('.Remove.the.pedestal') != null) document.querySelector('.Remove.the.pedestal').classList.remove('active');
                        // if(window.seqValue ==false ){ //n we have this line of code here, so when user click on accordion it should work on first click
                           if(document.getElementById('SKCD24U0GS')!=null) document.getElementById('SKCD24U0GS').classList.add('active');
                             //n added settimeout to not to break camera sequence visibilty on certain situations 
                             window.hotspotsList.setHotspotsActive([
                                { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                            ]);
                            setTimeout(() => {

                                window.scene.applySequence(window['SKCD24U0GS_zone7_on'], function () {
                                    //    if (window.seqValue == true) {
                                        if(document.getElementById('SKCD24U0GS-hotspot') != null) document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                                        if(document.getElementById('SKCD24U0GS-callout') != null) document.getElementById('SKCD24U0GS-callout').classList.add('active');
                                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"; //n added this condition to update the pedestal category not working so commented
                                        data.productStateSelectContext.previousId =  "underTheCounterPedestalsCategory"; //n
                                        data.productStateSelectContext.currentProductVisibilitySequence = "SKCD24U0GS_zone7_on";
                                        data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                                // } 
                                    })
                            }, 2100);
                     }

                    //  ---------------------------
                    if(data.productStateSelectContext.pedestalsPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory != "SWA2450GS" 
                    && (data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" && data.productStateSelectContext.previousCam == "walloven_cam")
                    && data.productStateSelectContext.wallOvenPosition == "zoneSeven"
                    ){
                        if(document.querySelector('.Remove.the.pedestal') != null) document.querySelector('.Remove.the.pedestal').classList.remove('active');
                        // if(window.seqValue ==false ){ //n we have this line of code here, so when user click on accordion it should work on first click
                            if(document.getElementById('SKCD24U0GS')!=null) document.getElementById('SKCD24U0GS').classList.add('active');
                            window.hotspotsList.setHotspotsActive([
                                { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                            ]);
                             //n added settimeout to not to break camera sequence visibilty on certain situations 
                            setTimeout(() => {

                                window.scene.applySequence(window['SKCD24U0GS_zone7_on'], function () {
                                    //    if (window.seqValue == true) {
                                        if(document.getElementById('SKCD24U0GS-hotspot') != null) document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                                        if(document.getElementById('SKCD24U0GS-callout') != null) document.getElementById('SKCD24U0GS-callout').classList.add('active');
                                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"; //n added this condition to update the pedestal category not working so commented
                                        data.productStateSelectContext.previousId =  "underTheCounterPedestalsCategory"; //n
                                        data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                                // }  
                                    })
                            }, 2100);
                     }
                    //  ---------------------------
                    if(data.productStateSelectContext.pedestalsPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SSC2489GS" // the updated condition
                    && (data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" && data.productStateSelectContext.previousCam == "walloven_cam")
                    && data.productStateSelectContext.wallOvenPosition == "zoneSeven"
                    ){
                        if(document.querySelector('.Remove.the.pedestal') != null) document.querySelector('.Remove.the.pedestal').classList.remove('active');
                        // if(window.seqValue ==false ){ //n we have this line of code here, so when user click on accordion it should work on first click
                           if(document.getElementById('SKCD24U0GS')!=null) document.getElementById('SKCD24U0GS').classList.add('active');
                              window.hotspotsList.setHotspotsActive([
                            { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                        ]);
                             //n added settimeout to not to break camera sequence visibilty on certain situations 
                            setTimeout(() => {
                                window.scene.applySequence(window['SKCD24U0GS_zone7_on'], function () {
                                    //    if (window.seqValue == true) {
                                        if(document.getElementById('SKCD24U0GS-hotspot') != null) document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                                        if(document.getElementById('SKCD24U0GS-callout') != null) document.getElementById('SKCD24U0GS-callout').classList.add('active');
                                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"; //n added this condition to update the pedestal category not working so commented
                                        data.productStateSelectContext.previousId =  "underTheCounterPedestalsCategory"; //n
                                        data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                                        })
                            }, 2100);
                     }

                     if( data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" 
                     && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" && data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                        if(document.getElementById('SKCD24U0GS-hotspot') != null) document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                        if(document.getElementById('SKCD24U0GS-callout') != null) document.getElementById('SKCD24U0GS-callout').classList.add('active');
                     }
                     
                //   ------------------------------------------
                    //Disable Cards which are not compataible 
                    //Remove previously disabled card class
                    let SKCD24U0GS = document.querySelector('#SKCD24U0GS');
                    let SKMD24U0ES = document.querySelector('#SKMD24U0ES');
                    let removePedestal = document.querySelector('#underTheCounterPedestalsCategoryhotspotAndCalloutRemove');
                       if(SKCD24U0GS!=null) SKCD24U0GS.classList.remove('opacityCard');
                       if(SKMD24U0ES!=null) SKMD24U0ES.classList.remove('opacityCard');
                       if(document.querySelector('.Remove.the.pedestal.menuItem')!=null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('opacityCard');

                    //Add class disabled to not compataible product
                    if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory=="SSC2489GS" &&
                    data.productStateSelectContext.pedestalsPosition == "zoneSeven"){
                        // if(SKMD24U0ES!=null) SKMD24U0ES.classList.add('opacityCard'); //#TPE 
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.remove('active');
                        if(SKCD24U0GS!=null) SKCD24U0GS.classList.remove('opacityCard');
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory != "") {
                            if(SKCD24U0GS!=null)    SKCD24U0GS.classList.add('active');
                        }
                    }

                    // if(data.productStateSelectContext.underTheCounterPedestalsCategory == "" && data.productStateSelectContext.pedestalsPosition == "zoneSeven" &&
                    // data.productStateSelectContext.wallOvenCategory == "SSC2489GS"){
                    // }

                    if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.wallOvenCategory=="SSC2489GS" && 
                    data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" && data.productStateSelectContext.pedestalsPosition == "zoneThree"){
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.add('opacityCard');
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.remove('active');
                        if(SKCD24U0GS!=null) SKCD24U0GS.classList.remove('opacityCard');
                        document.getElementById('underTheCounterPedestalsCategoryhotspotAndCalloutRemove').parentElement.classList.remove('active') //n added this line to remove the active on the- 
                        //underTheCounterPedestalsCategoryhotspotAndCalloutRemove when an product is active
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory != "") SKCD24U0GS.classList.add('active');
                    }

                    if(data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.wallOvenCategory=="SWA2450GS" &&
                     data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" ){
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.add('opacityCard');
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.remove('active');
                        if(SKCD24U0GS!=null) SKCD24U0GS.classList.remove('opacityCard');
                        // SKCD24U0GS.classList.add('active');
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" || data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal" ){
                        // if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS"){
                            SKCD24U0GS.classList.add('active');
                        }
                    }
                 

                    if(event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS"){
                        if(SKCD24U0GS!=null) SKCD24U0GS.classList.add('opacityCard');
                        if(SKCD24U0GS!=null) SKCD24U0GS.classList.remove('active');
                        if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active');
                        SKMD24U0ES.classList.remove('opacityCard');
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory != "") SKMD24U0ES.classList.add('active');
                    }
                    if(event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS"){
                        if(SKCD24U0GS!=null) SKCD24U0GS.classList.add('opacityCard');
                        if(SKCD24U0GS!=null) SKCD24U0GS.classList.remove('active');
                        if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active');
                        SKMD24U0ES.classList.remove('opacityCard');
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory != "") SKMD24U0ES.classList.add('active');
                        if (currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                        if (currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //n 
                    }
                    if(event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" && 
                        data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES"){
                            if(SKCD24U0GS!=null) SKCD24U0GS.classList.add('opacityCard');
                            if(SKCD24U0GS!=null) SKCD24U0GS.classList.remove('active');
                        if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active');
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.remove('opacityCard');
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory != "") SKMD24U0ES.classList.add('active');
                    }
                    if(event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" && 
                        data.productStateSelectContext.wallOvenPosition == "zoneThree" && data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS") {
                            if(SKCD24U0GS!=null)  SKCD24U0GS.classList.add('opacityCard');
                            if(SKCD24U0GS!=null)SKCD24U0GS.classList.remove('active');
                        if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active');
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.remove('opacityCard');
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory != "") SKMD24U0ES.classList.add('active');
                    }
                    if(event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" && 
                        data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.pedestalsPosition == "zoneThree" && 
                        data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && 
                        data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES"){
                           
                            if(SKCD24U0GS!=null)  SKCD24U0GS.classList.remove('active');
                        if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active');
                        if(SKCD24U0GS!=null) SKCD24U0GS.classList.add('opacityCard');
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.remove('opacityCard');
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory != "") SKMD24U0ES.classList.add('active');
                        if(document.getElementById('SKCD24U0GS-callout') != null) document.getElementById('SKCD24U0GS-callout').classList.remove('active');
                        if(document.getElementById('SKCD24U0GS-hotspot') != null) document.getElementById('SKCD24U0GS-hotspot').classList.remove('active');
                        if(document.getElementById('SKMD24U0ES-callout') != null) document.getElementById('SKMD24U0ES-callout').classList.add('active');
                        if(document.getElementById('SKMD24U0ES-hotspot') != null) document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                        // if(document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden';
                        if(document.getElementById('SKMD24U0ES-Open-btn') != null) document.getElementById('SKMD24U0ES-Open-btn').style.visibility = 'visible';
                    }
                    // this line of code is added here, to hide the hotspot of pedestal when, there is no walloven present in the zoneSeven
                    if(data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" && data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                        if(document.getElementById('SKMD24U0ES-Open-btn') != null) document.getElementById('SKMD24U0ES-Open-btn').style.visibility = "hidden";
                    }else if(data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS" && data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                        if(document.getElementById('SKMD24U0ES-Open-btn') != null) document.getElementById('SKMD24U0ES-Open-btn').style.visibility = "visible";
                    }

                    if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS" && data.productStateSelectContext.pedestalsPosition == "zoneSeven" 
                    && data.productStateSelectContext.currentCamtwo != "reset" && data.productStateSelectContext.currentCam != "drawer_zone7"){
                        if(document.getElementById('SKCD24U0GS-hotspot') != null) document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                        if(document.getElementById('SKCD24U0GS-callout') != null) document.getElementById('SKCD24U0GS-callout').classList.add('active');
                        if(document.getElementById('SKMD24U0ES-callout') != null) document.getElementById('SKMD24U0ES-callout').classList.remove('active');
                    }

                  if(data.productStateSelectContext.microwaveDrawerOvensCategory == "" && data.productStateSelectContext.pedestalsPosition == "zoneThree"){
                 
                    if(SKCD24U0GS!=null) SKCD24U0GS.classList.add('opacityCard');
                    if(SKMD24U0ES!=null) SKMD24U0ES.classList.add('opacityCard');

                    if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.add('opacityCard');
                   
                    if(document.getElementById('SKMD24U0ES-calloutContainer')){
                        let removeCallout = document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling.childNodes;
                        removeCallout[0].style.display = "none";
                    }

                    if(document.getElementById('SKMD24U0ES-calloutContainer')){
                        let removeCalloutcolor = document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling;
                        removeCalloutcolor.style.background = "transparent";
                    }
                    
                 
                  }

                  if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS" && data.productStateSelectContext.pedestalsPosition != "zoneThree"){
          
                    if(SKCD24U0GS!=null) SKCD24U0GS.classList.add('opacityCard');
                    if(SKMD24U0ES!=null) SKMD24U0ES.classList.add('opacityCard');
                    if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.add('opacityCard');
                    if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active');
                    }

                    if(data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES"){
                        if(SKMD24U0ES!=null) SKMD24U0ES.classList.remove('opacityCard');
                    if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('opacityCard');
                    if(document.getElementById('SKCD24U0GS-Open-btn') != null) document.getElementById('SKCD24U0GS-Open-btn').style.visibility = 'hidden';

                }

                //n added this condition to remove the active on the remove the pedestal button and add opacity to the GS pedestal while toggle using accordian icon
                    if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" &&
                    data.productStateSelectContext.pedestalsPosition == "zoneThree" && (data.productStateSelectContext.underTheCounterPedestalsCategory == "Remove the pedestal" || data.productStateSelectContext.underTheCounterPedestalsCategory == "")){
                 
                        if(document.getElementById('SKMD24U0ES') != null) document.getElementById('SKMD24U0ES').classList.add('opacityCard');
                        if(document.getElementById('SKCD24U0GS') != null) document.getElementById('SKCD24U0GS').classList.add('active');
                        // if(document.getElementById('SKCD24U0GS') != null) document.getElementById('SKCD24U0GS').classList.add('opacityCard');
                        // if(document.getElementById('SKMD24U0ES') != null) document.getElementById('SKMD24U0ES').classList.add('active');
                        document.querySelector('#underTheCounterPedestalsCategoryhotspotAndCalloutRemove').parentElement.classList.remove('active')
                    }
                
              
                if(data.productStateSelectContext.underTheCounterPedestalsCategory == "" ){
                    if (currentActiveProductHotspot != null) currentActiveProductHotspot.classList.remove('active')
                    if (currentActiveProductCallout != null) currentActiveProductCallout.classList.remove('active') //callout added after handleaccordion click
                }

                if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS" &&
                data.productStateSelectContext.pedestalsPosition == "zoneThree" && data.productStateSelectContext.underTheCounterPedestalsCategory == "SKCD24U0GS"){
                    
                    if(document.getElementById('SKMD24U0ES') != null) document.getElementById('SKMD24U0ES').classList.add('opacityCard');
                    if(document.getElementById('SKCD24U0GS') != null) document.getElementById('SKCD24U0GS').classList.add('active');
                   if( document.querySelector('#underTheCounterPedestalsCategoryhotspotAndCalloutRemove')!=null){
                    if(document.querySelector('#underTheCounterPedestalsCategoryhotspotAndCalloutRemove').parentElement!=null) document.querySelector('#underTheCounterPedestalsCategoryhotspotAndCalloutRemove').parentElement.classList.remove('active')
                   }
                }

                }else if( data.id == 'underTheCounterPedestalsCategoryRight' && data.productStateSelectContext.pedestalsPosition === "zoneThree"){

                    if(data.productStateSelectContext.microwaveDrawerOvensCategory === "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory === "SMD2470ASY"){
                       
                        // if (document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden';
                        if(document.getElementById('SKMD24U0ES-callout')) document.getElementById('SKMD24U0ES-callout').classList.add('active');
                        if(document.getElementById('SKMD24U0ES-hotspot')) document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                      
                        
                        if(document.getElementById('SKMD24U0ES')) document.getElementById('SKMD24U0ES').classList.add('active');
                        if(document.getElementById('SKCD24U0GS')) document.getElementById('SKCD24U0GS').classList.remove('active');
                        
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                        ])
                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"

                    }else if(data.productStateSelectContext.microwaveDrawerOvensCategory === "SMD2499FS"){
                     
                        // if (document.getElementById('SKCD24U0GS-Open--btn') != null) document.getElementById('SKCD24U0GS-Open--btn').style.visibility = 'hidden';
                        if(document.getElementById('SKCD24U0GS-callout')) document.getElementById('SKCD24U0GS-callout').classList.add('active');
                        if(document.getElementById('SKCD24U0GS-hotspot')) document.getElementById('SKCD24U0GS-hotspot').classList.add('active');
                        
                        if(document.getElementById('SKMD24U0ES')) document.getElementById('SKMD24U0ES').classList.remove('active');
                        if(document.getElementById('SKMD24U0ES')) document.getElementById('SKMD24U0ES').classList.add('opacityCard');
                        if(document.getElementById('SKCD24U0GS')) document.getElementById('SKCD24U0GS').classList.add('active');
                        
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                        ])
                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"


                    }

                         //@SH24JAN24CF added this condition to work the right side pedestal same as work on leftMenu click on hotspot
                if( event.target.id != "SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn" && event.target.id != "SKCD24U0GS-InstallBelowtheWallOven--btn" && 
                data.productStateSelectContext.pedestalsPosition == "zoneThree" && (data.productStateSelectContext.currentCam == "microdrawer_cam" || data.productStateSelectContext.currentCam == "drawer_zone7" || data.productStateSelectContext.currentCamtwo == "drawer_cam" || data.productStateSelectContext.currentCam=="drawer_cam") && 
                data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && (data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2489ES" || data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2470AS")){
                    // data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES";
                   
                    setTimeout(function(){
                     
                        window.scene.applySequence(window["A1_Drawer_SKMD24U0ES_vis"]);
                        if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                        if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                        if(document.getElementById('SKMD24U0ES-callout') != null) document.getElementById('SKMD24U0ES-callout').classList.add('active');
                        if(document.getElementById('SKMD24U0ES-hotspot') != null) document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                        // if(document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden';
                        data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                    },200)
                }

                }else if(data.id  == "remove_pedestal_zone_7"  && data.productStateSelectContext.pedestalsPosition === "zoneSeven"){
                   
                    if(document.getElementById('SKMD24U0ES')) document.getElementById('SKMD24U0ES').classList.remove('active');
                    if(document.getElementById('SWA2450GS')) document.getElementById('SWA2450GS').classList.remove('active');
                    if(document.getElementById('SSC2489GS')) document.getElementById('SSC2489GS').classList.add('active');

                    // console.log(data.productStateSelectContext.wallOvenCategory,'Walloven Category')
                    
    
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                        ])

                        if(data.productStateSelectContext.wallOvenPosition == "zoneThree"){
                            window.hotspotsList.setHotspotsActive([
                                { hsname: "refrigeratorCategory-hotspotBtn", isactive: false },
                                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                                { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                             
                                ])

                                setTimeout(() => {   
                                window.scene.applySequence(window["A1_walloven_SSC2489GS_vis"]);
                                  // the callback is removed here cause it was causing an issue here/-
                                    data.productStateSelectContext.wallOvenPosition = "zoneSeven";
                                    data.productStateSelectContext.pedestalsPosition = "zoneSeven";
                                    data.productStateSelectContext.wallOvenCategory = 'SSC2489GS';
                                
                                    handleHotspotsVisibility(data,event);
                                    // data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
        
                                    // currentActiveProductHotspot.classList.add('active')
                                    // currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click     // these line are commented cause it was causing issue
                                    
                                    document.getElementById('SSC2489GS-OpenOven--btn').style.visibility = 'hidden';
                                    document.getElementById('SSC2489GS-ControlPanel--btn').style.visibility = 'hidden';
                                    document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = 'hidden';
                                    
                                    document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'none';
                                    document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'none';
                                    document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.display = 'none';
        
                                    //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                                    data.productStateSelectContext.currentProductVisibilitySequence = 'A1_walloven_SSC2489GS_vis';
        
                                    // setTimeout(()=>{
                                    // document.getElementById('SSC2489GS-hotspot').classList.add('active');
                                    // document.getElementById('SSC2489GS-callout').classList.add('active');
                                    // },1000)
                                    setTimeout(() => {
                                        window.scene.applySequence(window["SKCD24U0GS_zone7_on"], function(){
                                            if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                            if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                            if(document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn') != null) document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn').style.display = 'flex';
                                           data.productStateSelectContext.previousId =  "underTheCounterPedestalsCategory"; //n
                                           data.productStateSelectContext.currentProductVisibilitySequence = "SKCD24U0GS_zone7_on" 
                                           data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;

                                        }); 

                                        //@SH24JAN24CF added this condition for adding a white blank on the right side when we install the pedestal to the front side after installing in the right side via hotspot
                                        if(isFrontInstalledAfterRightZoneWithGS){
                                         
                                          setTimeout(() => {
                                            window.scene.applySequence(window["LZ3_pedestal_vis_on"]);
                                          }, 1000);
                                        }

                                    }, 3000);

                                    for(let i=0; i < window.hotspotsList.hslist.length; i++){
                            
                                    if(data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                                        if(window.hotspotsList.hslist[i].hsname == "wallOvenCategory-hotspotBtn"){
                                        document.getElementById('wallOvenCategory-hotspotBtn').style.visibility="visible";
                                        // window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT'
                                        window.hotspotsList.hslist[i].nameOf3dObj = 'WALL_OVEN_HOTSPOT'
                                        }
                                    }
                            
                                }

                            }, 3000);
                       
                        }else{
                            if(data.productStateSelectContext.wallOvenCategory == "SWA2450GS" && data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                                setTimeout(() => {
                                    
                                    window.scene.applySequence(window["A1_walloven_SSC2489GS_vis"]);
                                      // the callback is removed here cause it was causing an issue here/-
                                        data.productStateSelectContext.wallOvenPosition = "zoneSeven";
                                        data.productStateSelectContext.pedestalsPosition = "zoneSeven";
                                        data.productStateSelectContext.wallOvenCategory = 'SSC2489GS';
                                     
                                        handleHotspotsVisibility(data,event);
                                        // data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
            
                                        // currentActiveProductHotspot.classList.add('active')
                                        // currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click     // these line are commented cause it was causing issue
                                        
                                        //to remove the disable remove the pedestal button on installation

                                        if(document.getElementById('Removethepedestal')) document.getElementById('Removethepedestal').classList.remove('opacityCard')
                                        document.getElementById('SSC2489GS-OpenOven--btn').style.visibility = 'hidden';
                                        document.getElementById('SSC2489GS-ControlPanel--btn').style.visibility = 'hidden';
                                        document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.visibility = 'hidden';
                                        
                                        document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'none';
                                        document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'none';
                                        document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.display = 'none';
            
                                        //n this condition is for, when user switches between walloven of same model in zone seven,it will change the vis seq,which will help us to call vis seq in productCard click
                                        data.productStateSelectContext.currentProductVisibilitySequence = 'A1_walloven_SSC2489GS_vis';
                                    
                                        window.hotspotsList.setHotspotsActive([
                                            { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                                        ]);
                                        setTimeout(() => {
                                            window.scene.applySequence(window["SKCD24U0GS_zone7_on"], function(){
                                                if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                                if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                                if(document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn') != null) document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn').style.display = 'flex';
                                               data.productStateSelectContext.previousId =  "underTheCounterPedestalsCategory"; //n
                                               data.productStateSelectContext.currentProductVisibilitySequence = "SKCD24U0GS_zone7_on" 
                                               data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                                            }); 
                                        }, 3000);
    
                                        for(let i=0; i < window.hotspotsList.hslist.length; i++){
                                                if(data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                                                if(window.hotspotsList.hslist[i].hsname == "wallOvenCategory-hotspotBtn"){
                                                document.getElementById('wallOvenCategory-hotspotBtn').style.visibility="visible";
                                                // window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT'
                                                window.hotspotsList.hslist[i].nameOf3dObj = 'WALL_OVEN_HOTSPOT'
                                                }
                                            }
                                        }

                                        window.hotspotsList.setHotspotsActive([
                                            { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                                            { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                                        ])
    
                                    }, 2000);
                            }else{
                               
                                window.hotspotsList.setHotspotsActive([
                                    { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                                ]);
                                setTimeout(() => {
                                    window.scene.applySequence(window["SKCD24U0GS_zone7_on"], function(){
                                        if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                                        if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                                        if(document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn') != null) document.getElementById('SKCD24U0GS-InstallBelowtheMicrowaveDrawer-btn').style.display = 'flex';
                                       data.productStateSelectContext.previousId =  "underTheCounterPedestalsCategory"; //n
                                       data.productStateSelectContext.currentProductVisibilitySequence = "SKCD24U0GS_zone7_on" 
                                       data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                                    }); 
                                }, 2000);
                            }
                        
                        }
                        
                    data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS";
                    data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                    if(document.getElementById('SKCD24U0GS')) document.getElementById('SKCD24U0GS').classList.add('active')
                    if(document.getElementById('Removethepedestal')) document.getElementById('Removethepedestal').classList.remove('active')

                       
                    handleHotspotsVisibility(data)
                }else if(data.id  == "remove_pedestal_zone_3" && data.productStateSelectContext.pedestalsPosition === "zoneThree"){
                    if(data.productStateSelectContext.microwaveDrawerOvensCategory == ""){
                        
                        window.scene.applySequence(window['B1_microdrawer_SMD2489ES_vis'],function(){
                            data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2489ES";
                            setTimeout(()=>{
                              
                                data.productStateSelectContext.currentProductVisibilitySequence = "B1_microdrawer_SMD2489ES_vis";
                                
                                window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_vis'],function(){
                                    data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
                                    data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                                    data.productStateSelectContext.pedestalsPosition = "zoneThree";
                                    document.querySelector(".SKCD24U0GS.menuItem").classList.add('opacityCard');
                                    document.querySelector(".SKMD24U0ES.menuItem").classList.add('active');
                                  
                                    document.getElementById('SKMD24U0ES-callout').classList.add('active');
                                    document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                                    if(document.getElementById('SKMD24U0ES-Open-btn') != null) document.getElementById('SKMD24U0ES-Open-btn').style.visibility = 'visible';

                                    if(document.getElementById("SMD2489ES")!=null)document.getElementById("SMD2489ES").classList.add('active');
                                    if(document.getElementById("Removethemicrowavedrawer")!=null) document.getElementById("Removethemicrowavedrawer").classList.remove('active');
                                 
                                  
                                    setTimeout(()=>{
                                        window.hotspotsList.setHotspotsActive([
                                            { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false },
                                            { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                                            { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false },
                                            { hsname: "SKMD24U0ES-Open-btn", isactive: true },
                                            
                                        ])
                                    },10)

                                    setTimeout(()=>{
                                      
                                        window.hotspotsList.setHotspotsActive([
                                            { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                                        ]);
                                        document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').style.visibility = "visible"
                                        document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').style.display = "flex"
                                        window.scene.clearRefine();
                                    },1000);

                                    if(data.productStateSelectContext.wallOvenPosition === "zoneThree" && data.productStateSelectContext.wallOvenCategory !== ""){
                                   
                                    setTimeout(()=>{
                                   
                                        window.hotspotsList.setHotspotsActive([
                                            { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                                        ])
                                    },10)
                                    }

                                });
                            },500)
                        })
                     }else if(data.productStateSelectContext.microwaveDrawerOvensCategory == "SMD2499FS"){
                        setTimeout(() => {
                            window.scene.applySequence(window['B1_Drawer_SKCD24U0GS_vis'], function () {
                                data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"
                                data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                                data.productStateSelectContext.pedestalsPosition = "zoneThree";
                                let pedestalActiveOne = document.querySelector('.SKCD24U0GS.menuItem')
                                if(document.querySelector('.SKCD24U0GS.menuItem')!=null)
                                pedestalActiveOne.classList.add('active');
                                if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active'); //n
                            });
                        }, 100);
                       
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                            { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                        ])

                        if(document.getElementById('SKCD24U0GS-hotspot')) document.getElementById('SKCD24U0GS-hotspot').classList.add('active')
                        if(document.getElementById('SKCD24U0GS-callout')) document.getElementById('SKCD24U0GS-callout').classList.add('active')

                        if(document.getElementById('SKMD24U0ES')) document.getElementById('SKMD24U0ES').classList.add('opacityCard')
                     }
                     else{
                            
                        window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_vis'],function(){
                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                            data.productStateSelectContext.pedestalsPosition = "zoneThree";
                            document.querySelector("#Removethepedestal").classList.remove('active');
                            document.querySelector(".SKCD24U0GS.menuItem").classList.add('opacityCard');
                            document.querySelector(".SKMD24U0ES.menuItem").classList.add('active');
                            
                         
                            document.getElementById('SKMD24U0ES-callout').classList.add('active');
                            document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                            if(document.getElementById('SKMD24U0ES-Open-btn') != null) document.getElementById('SKMD24U0ES-Open-btn').style.visibility = 'visible';
                    
                            setTimeout(() => {
                                window.hotspotsList.setHotspotsActive([
                                    { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false },
                                    { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false },
                                    { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true },
                                    { hsname: "SKMD24U0ES-Open-btn", isactive: true }
                                ])
                            }, 10);
                        });

                     }                 
                }

                if(data.id == "microwaveDrawerOvensCategory" && data?.menuItems[0]?.title == "SMD2499FS" && data.menuItemLength == 1){
                // data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2499FS"
                   document.querySelector("#SMD2499FS").classList.add('active');

                //    accordionContentContainer microwaveDrawerOvensCategory expand
                //    let microWaveheight = document.querySelector("#SMD2499FS").parentElement;
                //    microWaveheight.style.height = "132px";
                   
                //    console.log("microWaveheight",microWaveheight);
                   setTimeout(() => {
                    window.scene.applySequence(window['B1_Drawer_SKCD24U0GS_vis'], function () {
                        data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"
                        data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                        data.productStateSelectContext.pedestalsPosition = "zoneThree";
                        let pedestalActiveOne = document.querySelector('.SKCD24U0GS.menuItem')
                        if(document.querySelector('.SKCD24U0GS.menuItem')!=null)
                        pedestalActiveOne.classList.add('active');
                        if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active'); //n
                    });
                }, 2000);

                }

               
               
            if (window.seqValue == false) {
                    if(currentActiveProductCallout != null) currentActiveProductCallout.classList.add('active') //callout added after handleaccordion click
                    if(currentActiveProductHotspot != null) currentActiveProductHotspot.classList.add('active')
                    setcalloutInfo(true);
            }
        }
      
        if(data.id == "installmicrowaveDrawerOven"){
                    //   let accordionExpandWalloven = document.getElementById('wallOvenCategoryBtn').classList.add('active');
                      document.getElementById('microwaveDrawerOvensCategoryBtn').classList.add('active');
                      document.querySelector('.accordionContentContainer.microwaveDrawerOvensCategory').classList.add('expand');
                      document.querySelector('.accordionContentContainer.microwaveDrawerOvensCategory').style.height = "849px";
                      document.getElementById('microwaveDrawerOvensCategoryIconBtn').classList.add('active');
                      document.getElementById('SMD2489ES').classList.add('active');
                      document.getElementById('Removethemicrowavedrawer').classList.remove('active');
                      let checkValue= document.getElementById('SMD2470AS').nextElementSibling;
                      checkValue.classList.remove('active');
                
                if(data.productStateSelectContext.microwaveDrawerOvensCategory == ""){

                    // if(document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden'; //2
                    window.scene.applySequence(window['B1_microdrawer_SMD2489ES_vis'],function(){
                        setTimeout(()=>{
                            data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2489ES";
                            data.productStateSelectContext.currentProductVisibilitySequence = "B1_microdrawer_SMD2489ES_vis";
                            document.getElementById('SMD2489ES-callout').classList.add('active');
                            document.getElementById('SMD2489ES-hotspot').classList.add('active');
                  
                            window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_vis'],function(){
                                data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
                                data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                                data.productStateSelectContext.pedestalsPosition = "zoneThree";
                                document.querySelector(".SKCD24U0GS.menuItem").classList.add('opacityCard');
                                document.querySelector(".SKMD24U0ES.menuItem").classList.add('active');
                                if(document.getElementById('SKMD24U0ES-Open-btn') != null) document.getElementById('SKMD24U0ES-Open-btn').style.visibility = 'visible';
                                
                                setTimeout(()=>{
                                    window.hotspotsList.setHotspotsActive([
                                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                                        { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                                    ])
                                },10)
                            });
                        },500)
                    })
                 }                  
            }
       
        // if(data.id != "installWallovenInrightSide"){
            // console.log("data.index 2532",data.index);

        siblingAccordionContent.style.height = siblingAccordionContentHeight + 'px'

        var menuIndex = data.index;
        if(data.index == 9 || data.index == 10 || data.index == 11 || data.index == 12 ){
            menuIndex = 7;
        }
        else if(data.index == 13 || (data.index == 2 && data.id == "installmicrowaveDrawerOven") || data.index ==14 ){
            menuIndex = 2;
        }
        else if( (data.index == 15 && data.id == "remove_pedestal_zone_7") || (data.index == 16 && data.id == "remove_pedestal_zone_3") ){
            menuIndex = 2;
        }
       

        // if (!requiredPopUpId.includes(data.categoryId) && !requiredIconId.includes(data.iconId) && !requiredHotspotId.includes(data.hotspotId)) {
            // console.log("menuIndex * 49",menuIndex * 49);
            menuContainer.scrollTop = menuIndex * 49
            
            console.log("menuContainer.scrollTop",menuIndex * 49);

        // ------------------
        // attr code
        let getHotspotControlp = document.querySelector(
            '.hotspotInternalBtn.active',
        )
        let getHotspotControlpSpan = document.querySelector(
            '.hotspotInternalBtn.active .internalhotspotText',
        )
        if (getHotspotControlp != null) {
            let getHotspotControlpInfo = getHotspotControlp.getAttribute('data-info')
          
            if (getHotspotControlpInfo != null) {
                let getHotspotControlpInfoJSON = JSON.parse(getHotspotControlpInfo)
                getHotspotControlpSpan.innerHTML = getHotspotControlpInfoJSON.hotspotText.replace(/-/g, '')
            }
            getHotspotControlp.classList.remove('active')
        }

        //@uthor - YK: Added for collaps callout accordion on click of menu accordion
        let getActiveCalloutAccordion = document.querySelector('.accordionContentContainer.expandCallout')
        let getOtherActiveCalloutAccordion = document.querySelector('.calloutsContainer.active .accordionHeading.active')

        if (getActiveCalloutAccordion != null) {
            getActiveCalloutAccordion.style.height = '0px'
            getActiveCalloutAccordion.classList.remove('expandCallout')
        }
        if (getOtherActiveCalloutAccordion != null) {
            getOtherActiveCalloutAccordion.classList.remove('active')
        }
        data.productStateSelectContext.previousPedestalZone = data.productStateSelectContext.pedestalsPosition;

        if(data.camSequencetwo != ""){
            data.productStateSelectContext.currentCamtwo = data.camSequencetwo
        }

        //n this conditon is added to show to zoomout button when the pedestal and microwaveDrawerOvens is removed
    if (!popUpVisibiltyCams.includes(data.productStateSelectContext.currentCam) && data.productStateSelectContext.underTheCounterPedestalsCategory == "" && data.productStateSelectContext.microwaveDrawerOvensCategory == "" && (data.productStateSelectContext.currentCam == "microdrawer_cam" || (data.productStateSelectContext.currentCamtwo == "drawer_cam" && data.productStateSelectContext.pedestalsPosition == "zoneThree" ))) {
            
            if(data.productStateSelectContext.currentCam == "microdrawer_cam"){
               if(document.querySelector('#SMD2470AS-calloutContainer') != null){
               if(document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling!=null) document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling.classList.add('active');
               }
            if(document.querySelector('#SKMD24U0ES-calloutContainer') != null){
               if(document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling!=null) document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling.classList.remove('active');
            } 

            }else{
                if(document.querySelector('#SKMD24U0ES-calloutContainer') != null){
                  if(document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling!=null) document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling.classList.add('active');
                } 
                if(document.querySelector('#SMD2470AS-calloutContainer') != null){
                  if(document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling!=null) document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling.classList.remove('active');
                } 
            }
        }else{
           if(document.querySelector('#SKMD24U0ES-calloutContainer') != null){
            if(document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling!=null) document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling.classList.remove('active');
           } 
           if(document.querySelector('#SMD2470AS-calloutContainer') != null){
            if(document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling!=null) document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling.classList.remove('active');
           } 
        }

        data.productStateSelectContext.previousCam = data.productStateSelectContext.currentCam
        // setTimeout(()=>{
            // opacityFlag = false;

        // },3000)
        // checkForOverLay();
        if(document.getElementById('SJB1255GS-ControlPanelLight-btn')!=null) document.getElementById('SJB1255GS-ControlPanelLight-btn').style.visibility = 'hidden'; //n this line added so, that whenever user switching, prod in beetween animation, it shouldn't be displayed
        if(document.getElementById('SJB1255GS-CrisperFreshConverterDrawers-btn')!=null) document.getElementById('SJB1255GS-CrisperFreshConverterDrawers-btn').style.visibility = 'hidden';
        
        if(data.productStateSelectContext.underTheCounterPedestalsCategory == "" && data.productStateSelectContext.pedestalsPosition == "zoneSeven" && data.productStateSelectContext.wallOvenCategory == "SWA2450GS"){
          
            if(document.getElementById('SKMD24U0ES-calloutContainer') != null) document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling.classList.add('active') 
            
            if(document.getElementById('SKMD24U0ES-calloutContainer')){
                let removeCallout = document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling.childNodes;
                removeCallout[0].style.display = "none";
            }
            
            if(document.getElementById('SKMD24U0ES-calloutContainer')){
                let removeCalloutcolor = document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling;
                removeCalloutcolor.style.background = "transparent";
            }
          
          }


          setTimeout(() => {
            if(data.productStateSelectContext.underTheCounterPedestalsCategory == "SKMD24U0ES" && data.productStateSelectContext.pedestalsPosition == "zoneThree"){

            if(document.getElementById('SKCD24U0GS')) document.getElementById('SKCD24U0GS').classList.remove('active')
        }
          }, 3500);
        //   console.log(data.productStateSelectContext.underTheCounterPedestalsCategory,'underTheCounterPedestalsCategory----');
        //   console.log(data.productStateSelectContext.pedestalsPosition,'pedestalsPosition-----');
      
          
          handleHotspotsVisibility(data,event);

        }

    var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
    useEffect(() => {
        if (mob) {
            setcalloutInfo(false);
            document.getElementById('internalCalloutsAndHotspots').style.display='block';
        }
    })

    const [internalHotspot, setInternalHotspot] = useState(false);
    const [productCategoryHotspot, setproductCategoryHotspot] = useState(true)

    //function calls on the internal hotspots (open/close products)
    const hotspotClick = (event, data) => {



        if(window.mob){
            if(document.querySelector('.zoomoutButtonNew')) document.querySelector('.zoomoutButtonNew').style.display = "flex"
            if(document.getElementById('installWallovenInrightSide-hotspotBtn') != null) document.getElementById('installWallovenInrightSide-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('microwaveDrawerOvensCategory-hotspotBtn') != null) document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('underTheCounterPedestalsCategoryRight-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategoryRight-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('remove_pedestal_zone_3-hotspotBtn') != null) document.getElementById('remove_pedestal_zone_3-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('installmicrowaveDrawerOven-hotspotBtn') != null) document.getElementById('installmicrowaveDrawerOven-hotspotBtn').classList.remove('mobresetzonethreehs');
            if(document.getElementById('installWalloneOneInright-hotspotBtn') != null) document.getElementById('installWalloneOneInright-hotspotBtn').classList.remove('mobresetzonethreehs');

            if(data.wallOvenPosition == "zoneThree"){
                if(document.getElementById('wallOvenCategory-hotspotBtn') != null) document.getElementById('wallOvenCategory-hotspotBtn').classList.remove('mobresetzonethreehs');
           }
        }

    let getActiveCalloutAccordion = document.querySelector('.accordionContentContainer.expandCallout');
    let getOtherActiveCalloutAccordion = document.querySelector('.calloutsContainer.active .accordionHeading.active');

    if (getActiveCalloutAccordion != null) {
        getActiveCalloutAccordion.style.height = '0px';
        getActiveCalloutAccordion.classList.remove('expandCallout');
    }
    if (getOtherActiveCalloutAccordion != null) {
        getOtherActiveCalloutAccordion.classList.remove('active');
    }


        handleHotspotsVisibility(data,event);
       
        event.persist();
        let hotspotTextValue;
        let hotspotTextMainInternal;
        let currentBtn = event.target.closest('button')

        let currentBtnSpan = document.querySelector('#' + currentBtn.id + ' .internalhotspotText');
        // let currentBtnId = event.target.id.split('-btn');
        let currentBtnId = currentBtn.id.split('-btn') //2
        let currentTargetInternalCallout = document.getElementById(currentBtnId[0])
        let currentProductTitle = currentBtnId[0].split('-')
        currentProductTitle = currentProductTitle[0]

        let currentTargetParentCallout = document.getElementById(currentProductTitle + '-callout');

        // console.log("data.hotspotText 2406",data.hotspotText)

            // if(data.id == "refrigeratorCategory"){
               
            // }

            if(data.id != "cooktopCategory"){
                hotspotTextMainInternal = data.hotspotText.replace(/-/g, '');
            }
            else if(data.id == "cooktopCategory"){
                hotspotTextMainInternal =  data.hotspotText;
            }

            if(data.hotspotText == "Control Panel Light"){
                hotspotTextMainInternal = "Control Panel & Light";
            }
            else if(data.hotspotText == "Crisper Fresh Converter Drawers"){
                hotspotTextMainInternal = "Crisper & Fresh Converter Drawers";
            }

            hotspotTextValue = hotspotTextMainInternal;

        if (currentBtn.classList.contains('active')) {
            currentBtn.classList.remove('active')
            currentBtnSpan.innerHTML = hotspotTextValue

            if (data.productActiveAnimation != '') {
                window.scene.applySequence(window[data.productActiveAnimation])
            }
            let currentActiveCallout = document.querySelector(
                '.calloutsContainer.active',
            )
            if (currentActiveCallout != null) {
                currentActiveCallout.classList.remove('active')
            }

            //added this condition for refrigerator only;

            if(data?.id == "refrigeratorCategory" && data?.productActiveAnimation == "A2_refrigerator_SJB1255GS_CP_Close" && 
            (data?.hotspotText == "Crisper Fresh Converter Drawers" || data?.hotspotText == "Control Panel Light") && (currentBtn?.id == "SJB1255GS-CrisperFreshConverterDrawers-btn" || currentBtn?.id == "SJB1255GS-ControlPanelLight-btn")
            && currentProductTitle == "SJB1255GS"            
            ){
                // console.log('condition added for referegerator only...!');

                if(document.getElementById('SJB1255GS-OpenFridgeandFreezerDoors')) document.getElementById('SJB1255GS-OpenFridgeandFreezerDoors').classList.add('active');

            }else{
                currentTargetParentCallout.classList.add('active')
            }

    
        } else {
            let getHotspotControlp = document.querySelector('.hotspotInternalBtn.active');
            let getHotspotControlpSpan = document.querySelector('.hotspotInternalBtn.active .internalhotspotText');

            if (getHotspotControlp != null) {
                let getHotspotControlpInfo = getHotspotControlp.getAttribute('data-info');

                if (getHotspotControlpInfo != null) {
                    let getHotspotControlpInfoJSON = JSON.parse(getHotspotControlpInfo)

                    // getHotspotControlp.innerHTML = getHotspotControlpInfoJSON.hotspotText;

                    if (currentBtn.id != 'SJB1255GS-ControlPanelLight-btn' && currentBtn.id != 'SJB1255GS-CrisperFreshConverterDrawers-btn') {
                        getHotspotControlpSpan.innerHTML = getHotspotControlpInfoJSON.hotspotText
                    }

                }
                if (currentBtn.id != 'SJB1255GS-ControlPanelLight-btn' && currentBtn.id != 'SJB1255GS-CrisperFreshConverterDrawers-btn') {
                    getHotspotControlp.classList.remove('active');
                }
               
            }
            // nameOf3dObj
            currentBtn.classList.add('active')
            currentBtnSpan.innerHTML = data.hotspotTextActive

            if (data.productAnimation != '') {
                window.scene.applySequence(window[data.productAnimation])
            }

            let currentActiveCallout = document.querySelector('.calloutsContainer.active');

            if (currentActiveCallout != null) {
                currentActiveCallout.classList.remove('active')
            }
            currentTargetInternalCallout.classList.add('active')
        }

      
        setcalloutInfo(true);


        if(data.id === "refrigeratorCategory"){

        // let refrigeratorDoor = document.getElementById('SJB1255GS-OpenFridgeDoor-btn');
        let refrigeratorDoor = document.getElementById('SJB1255GS-OpenFridgeandFreezerDoors-btn');
        let refrigeratorshowControlPanel = refrigeratorDoor.classList.contains('active');
        if (refrigeratorshowControlPanel == true) {
            setTimeout(() => {
                document.getElementById('SJB1255GS-ControlPanelLight-btn').style.visibility = 'visible';
                document.getElementById('SJB1255GS-CrisperFreshConverterDrawers-btn').style.visibility = 'visible';
            }, 2500)
        }
        let refrigeratorshowCP = refrigeratorDoor.classList.contains('active');
        if (refrigeratorshowCP == false) {
            setTimeout(() => {
                document.getElementById('SJB1255GS-ControlPanelLight-btn').style.visibility = 'hidden';
                document.getElementById('SJB1255GS-CrisperFreshConverterDrawers-btn').style.visibility = 'hidden';
            }, 1000)
        }
        };


    }

    //function to execute the visibility sequence of the different different product visibility in each category
    const productCardClicked = (event, data) => {

        if(data.itemCategory == 'underTheCounterPedestalsCategory' && (data.cardDetails.title == "Remove the pedestal" || data.cardDetails.title == "")
            && data.productStateSelectContext.pedestalsPosition === "zoneThree" 
        ){
            data.productStateSelectContext.currentProductVisibilitySequence = ""
        }
        
        // console.log(data,'data-----2788')
        // console.log('data.productStateSelectContext.microwaveDrawerOvensCategory',data.productStateSelectContext.microwaveDrawerOvensCategory);
        // console.log('data.cardDetails.productVisibilitySequence',data.cardDetails.productVisibilitySequence);
        // console.log('data.productStateSelectContext.currentProductVisibilitySequence',data.productStateSelectContext.currentProductVisibilitySequence);
        // opacityFlag = true;
        setcalloutInfo(true); // when user clicks multiple time on the same product, it won't the zoomout button show hide, that is why this condition is added here only/-
        // checkForOverLay();
        if(document.querySelector('#SKMD24U0ES-calloutContainer') != null){
            if(document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling!=null) document.querySelector('#SKMD24U0ES-calloutContainer').nextElementSibling.classList.remove('active');// added this condition for removing microwave zommout button
        } 
        if(document.querySelector('#SMD2470AS-calloutContainer') != null){
          if(document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling!=null)  document.querySelector('#SMD2470AS-calloutContainer').nextElementSibling.classList.remove('active'); // added this condition for removing pedestal zommout button
        } 
        if(document.querySelector(".SKCD24U0GS.menuItem") != null) document.querySelector(".SKCD24U0GS.menuItem").classList.remove('active');
        if(document.querySelector(".SKMD24U0ES.menuItem") != null) document.querySelector(".SKMD24U0ES.menuItem").classList.remove('active');
      
        // document.getElementById('productCategoryHotspot').style.display='none'; //

        let currentTarget = event.target.closest('button').parentElement
        let getAllMenuUtemOfSameCategory = currentTarget.parentElement.children

        
        let currentTargetCallout = document.getElementById(data.cardDetails.title + '-callout');
        let currentTargetHotspot = document.getElementById(data.cardDetails.title + '-hotspot');

        let currentActiveCallout = document.querySelector('.calloutsContainer.active')
        let currentActiveHotspot = document.querySelector('.hotspotContainer.active')

        // hidding hotspot callout's
        if(document.getElementById('Remove the microwave drawer-hotspot') != null) document.getElementById('Remove the microwave drawer-hotspot').style.display='none'
        // the code present below is to turn of pedestals
        if(data.itemCategory == "microwaveDrawerOvensCategory"){
            // data.productStateSelectContext.wallOvenPosition = "zoneThree";
            if(data.cardDetails.title == "Remove the microwave drawer"){
                setTimeout(()=>{
                    window.scene.applySequence(window['LZ3_pedestal_vis_on']);
                    data.productStateSelectContext.microwaveDrawerOvensCategory = "";
                    data.productStateSelectContext.underTheCounterPedestalsCategory = "";
                    data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = true;
                    data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = true;

                    },1000)

                if(document.getElementById('SMD2470AS-calloutContainer') !== null ||document.getElementById('SMD2470AS-calloutContainer') !== undefined ){
                    let removeCallout = document.getElementById('SMD2470AS-calloutContainer').nextElementSibling.childNodes;
                    removeCallout[0].style.display = "none";
                }
             
                if(document.getElementById('SMD2470AS-calloutContainer')){
                    let removeCalloutcolor = document.getElementById('SMD2470AS-calloutContainer').nextElementSibling;
                    removeCalloutcolor.style.background = "transparent";
                }


                setTimeout(()=>{
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true }
                    ])
                },100)

                //Changes//- for removing the active from the remove MD click
                if(document.getElementById('SMD2440JS-calloutContainer')) {
                    let RemovethemicrowavedrawerBox=  document.getElementById('SMD2440JS-calloutContainer').nextElementSibling;

                    if(RemovethemicrowavedrawerBox !== null && RemovethemicrowavedrawerBox !== undefined){
                        RemovethemicrowavedrawerBox.style.visibility = "hidden";
                        if(RemovethemicrowavedrawerBox.querySelector('.zoomOutBtn')) RemovethemicrowavedrawerBox.querySelector('.zoomOutBtn').style.visibility = "visible"
                    }
                }
            
            }
            //  the block of code present below can be used later
            // else if(data.cardDetails.title == "SMD2499FS"){
            //     data.productStateSelectContext.currentProductVisibilitySequence = "";
            // }


        }

        if (currentActiveCallout != null) {
            currentActiveCallout.classList.remove('active')
        }
        let getAllMenuUtemOfSameCategoryArr = [...getAllMenuUtemOfSameCategory]
        getAllMenuUtemOfSameCategoryArr.forEach((element) => {
            if (element.classList.contains('active')) {
                element.classList.remove('active')
            }
        })

        if (currentActiveHotspot != null) {
            currentActiveHotspot.classList.remove('active')
        }

            currentTarget.classList.add('active') 
                    
            currentTargetCallout.classList.add('active')     //callout's active 
            currentTargetHotspot.classList.add('active')     //hotspot active
        
              
// ------------------------------------------------

            if(data.cardDetails.title === "SKMD24U0ES"){
                data.productStateSelectContext.pedestalsPosition = "zoneThree"
            }

        if (
            data.cardDetails.productVisibilitySequence != ''
            && data.cardDetails.productVisibilitySequence != data.productStateSelectContext.currentProductVisibilitySequence
            // && (data.cardDetails.productVisibilitySequence != "B1_microdrawer_SWA2450GS_vis" && data.productStateSelectContext.wallOvenPosition != "zoneThree")
            && data.cardDetails.productVisibilitySequence != "A1_otcmicro_R1214TY_vis"
            && data.cardDetails.productVisibilitySequence != 'A1_refrigerator_SJB1255GS_vis'
            && data.cardDetails.productVisibilitySequence != 'A1_rangehood_SMO1461GS_vis'
            && data.cardDetails.productVisibilitySequence != 'B1_rangehood_SHC2432FS_vis'
            // &&((data.cardDetails.title != "Remove the pedestal" && data.cardDetails.title != "")&&data.itemCategory == "underTheCounterPedestalsCategory")
            // || (data.cardDetails.productVisibilitySequence != "B1_microdrawer_SWA2450GS_vis" && data.productStateSelectContext.wallOvenPosition == "zoneThree")
        ) {
            
            //added this code to handle the visibility state of the pedestals;

            // console.log(data.cardDetails.productVisibilitySequence,'seq Name')
            // if(data.cardDetails.productVisibilitySequence === "")
            
            if(data.cardDetails.productVisibilitySequence === "A1_Drawer_SKMD24U0ES_vis"){
                data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
            }else if(data.cardDetails.productVisibilitySequence === "B1_Drawer_SKCD24U0GS_vis"){
                data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
            }
            //@SH24JAN24CF => added this condition for hotspot issue
            if(data.cardDetails.productVisibilitySequence === "B1_microdrawer_SWA2450GS_vis" && data.cardDetails.title === "SWA2450GS"
            && data.productStateSelectContext.pedestalsPosition == "zoneSeven"
            ){
           
                data.productStateSelectContext.zoneSevenPedestalRemovedStatus = true;
            }


            window.scene.applySequence(
                window[data.cardDetails.productVisibilitySequence], function () {
                    handleHotspotsVisibility(data,event);
                    if (window.seqValue == true) {
                        currentTargetCallout.classList.add('active');
                        currentTargetHotspot.classList.add('active');
                    }

            if(data.itemCategory == "microwaveDrawerOvensCategory"){
                if(data.cardDetails.title == "SMD2499FS"){
                    data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = false;
                        setTimeout(() => {

                            window.scene.applySequence(window['B1_Drawer_SKCD24U0GS_vis'], function () {
                                data.productStateSelectContext.underTheCounterPedestalsCategory = "SKCD24U0GS"
                                data.productStateSelectContext.pedestalsPosition = "zoneThree";
                                let pedestalActiveOne = document.querySelector('.SKCD24U0GS.menuItem')
                                if(document.querySelector('.SKCD24U0GS.menuItem')!=null)
                                pedestalActiveOne.classList.add('active');
                                if(document.querySelector('.Remove.the.pedestal.menuItem') != null) document.querySelector('.Remove.the.pedestal.menuItem').classList.remove('active'); //n
                                
                            });
                        }, 100);
                      
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                            { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                        ])
                    // }
                }
                else if(data.cardDetails.title == "SMD2489ES"){
                //    if(document.getElementById('SKMD24U0ES-Open--btn') != null) document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden'; //2
                    setTimeout(()=>{
                       
                        window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_vis'],function(){
                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                            data.productStateSelectContext.pedestalsPosition = "zoneThree";
                            currentTargetHotspot.classList.add('active')
                            currentTargetCallout.classList.add('active')
                            if(document.querySelector(".SKCD24U0GS.menuItem")!=null)
                            document.querySelector(".SKCD24U0GS.menuItem").classList.add('opacityCard');
                            if(document.querySelector(".SKMD24U0ES.menuItem")!=null)
                            document.querySelector(".SKMD24U0ES.menuItem").classList.add('active');
                            if(document.getElementById('SKMD24U0ES-Open-btn') != null) document.getElementById('SKMD24U0ES-Open-btn').style.visibility = 'visible';
                        });
                        },100)
              
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                            { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                        ])
                }
                else if(data.cardDetails.title == "SMD2470AS"){

                    // document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden'; //3
                    
                    setTimeout(()=>{
                        
                        window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_vis'],function(){
                            data.productStateSelectContext.pedestalsPosition = "zoneThree";
                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                            let pedestalActiveTwo = document.querySelector('.SKMD24U0ES.menuItem')
                            pedestalActiveTwo.classList.add('active');
                            currentTargetHotspot.classList.add('active')
                            currentTargetCallout.classList.add('active')
                        });
                        },100)
                   
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                            { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                        ])
                }
                else if(data.cardDetails.title == "SMD2470AH"){

                    // document.getElementById('SKMD24U0ES-Open--btn').style.visibility = 'hidden'; //3
               
                    setTimeout(()=>{
                    
                        window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_vis'],function(){
                            data.productStateSelectContext.pedestalsPosition = "zoneThree";
                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                            let pedestalActiveTwo = document.querySelector('.SKMD24U0ES.menuItem')
                            pedestalActiveTwo.classList.add('active');
                            currentTargetHotspot.classList.add('active')
                            currentTargetCallout.classList.add('active')
                           
                            window.hotspotsList.setHotspotsActive([
                                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                                { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                            ])

                            if(document.getElementById('SKCD24U0GS')) document.getElementById('SKCD24U0GS').classList.add('opacityCard');
                            
                            // if(document.getElementById('SKMD24U0ES-hotspot')) document.getElementById('SKMD24U0ES-hotspot').classList.add('active');
                            // if(document.getElementById('SKMD24U0ES-callout')) document.getElementById('SKMD24U0ES-callout').classList.add('active');
                        });
                        },100)
                }else if(data.cardDetails.title == "SMD2479JS"){
                    // changes for installing the pedestal on selection of SMD2479JS microwave//
                    setTimeout(()=>{
                    
                        window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_vis'],function(){
                            data.productStateSelectContext.pedestalsPosition = "zoneThree";
                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                            let pedestalActiveTwo = document.querySelector('.SKMD24U0ES.menuItem')
                            pedestalActiveTwo.classList.add('active');
                            currentTargetHotspot.classList.add('active')
                            currentTargetCallout.classList.add('active')
                           
                            window.hotspotsList.setHotspotsActive([
                                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                                { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                            ])

                            if(document.getElementById('SKCD24U0GS')) document.getElementById('SKCD24U0GS').classList.add('opacityCard');
                        });
                        },100)
                }else if(data.cardDetails.title == "SMD2440JS"){
                    // changes for installing the pedestal on selection of SMD2440JS microwave//
                    setTimeout(()=>{
                    
                        window.scene.applySequence(window['A1_Drawer_SKMD24U0ES_vis'],function(){
                            data.productStateSelectContext.pedestalsPosition = "zoneThree";
                            data.productStateSelectContext.underTheCounterPedestalsCategory = "SKMD24U0ES"
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = false;
                            let pedestalActiveTwo = document.querySelector('.SKMD24U0ES.menuItem')
                            pedestalActiveTwo.classList.add('active');
                            currentTargetHotspot.classList.add('active')
                            currentTargetCallout.classList.add('active')
                           
                            window.hotspotsList.setHotspotsActive([
                                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                                { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: false }
                            ])

                            if(document.getElementById('SKCD24U0GS')) document.getElementById('SKCD24U0GS').classList.add('opacityCard');
                        });
                        },100)
                }
              else if(data.cardDetails.title == "Remove the microwave drawer"){
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                    ])
                }
            }

            if(data.itemCategory == "wallOvenCategory"){
                if(data.productStateSelectContext.wallOvenCategory == "SSC2489GS" && data.productStateSelectContext.wallOvenPosition == "zoneSeven"){
                data.productStateSelectContext.underTheCounterPedestalsCategory = "";
                }
            }

            if(data.itemCategory == "underTheCounterPedestalsCategory" && data.productStateSelectContext.underTheCounterPedestalsCategory === "SKMD24U0ES"){
                data.productStateSelectContext.pedestalsPosition = "zoneThree";
            }

            if(data.itemCategory == "underTheCounterPedestalsCategory"){

                window.hotspotsList.setHotspotsActive([
                   { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                //    { hsname: "SKMD24U0ES-Open--btn", isactive: false }
                ]) 
            
                if(data.productStateSelectContext.underTheCounterPedestalsCategory === "SKMD24U0ES" && data.productStateSelectContext.pedestalsPosition === "zoneThree"){
                    document.querySelector(".SKCD24U0GS.menuItem").classList.add('opacityCard');
                }
            }
    }
        )

            if(data.itemCategory == 'underTheCounterPedestalsCategory'){

                if(data.cardDetails.title == "Remove the pedestal" || data.cardDetails.title == ""){
            if(data.productStateSelectContext.pedestalsPosition === "zoneSeven"){
                    window.scene.applySequence(window[data.cardDetails.productVisibilitySequence],function(){
                   data.productStateSelectContext.underTheCounterPedestalsCategory = "";
                   data.productStateSelectContext.currentProductVisibilitySequence = "SKCD24U0GS_zone7_off";
                   data.productStateSelectContext.zoneSevenPedestalRemovedStatus = true;
                   
                });
                }else if(data.productStateSelectContext.pedestalsPosition === "zoneThree"){
                     window.scene.applySequence(window[data.cardDetails.productVisibilitySequencetwo]);
                     data.productStateSelectContext.currentProductVisibilitySequence = "LZ3_pedestal_vis_on";

                     window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                        ])

                      
                        if(data.productStateSelectContext.underTheCounterPedestalsCategory === "SKCD24U0GS"){
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKCD24U0GS = true;
                        }else if(data.productStateSelectContext.underTheCounterPedestalsCategory === "SKMD24U0ES"){
                            data.productStateSelectContext.zoneThreePedestalRemovedStatus.SKMD24U0ES = true;
                        }
                     
                }

                if(document.getElementById('SKMD24U0ES-calloutContainer')){
                    let removeCallout = document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling.childNodes;
                    removeCallout[0].style.display = "none";
                }
              
                if(document.getElementById('SKMD24U0ES-calloutContainer')){
                    let removeCalloutcolor = document.getElementById('SKMD24U0ES-calloutContainer').nextElementSibling;
                    removeCalloutcolor.style.background = "transparent";
                }
               

                setTimeout(()=>{
                        window.hotspotsList.setHotspotsActive([
                            { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: false },
                            { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                        ])
                },1000)

                }

                if(data.cardDetails.title == "SKMD24U0ES" && data.productStateSelectContext.pedestalsPosition === "zoneThree"
                 && data.productStateSelectContext.microwaveDrawerOvensCategory == ""
                ){
           

                    setTimeout(() => {
                       
                        window.scene.applySequence(window["B1_microdrawer_SMD2489ES_vis"],()=>{
                            data.productStateSelectContext.microwaveDrawerOvensCategory = "SMD2489ES";
                            if(document.getElementById('Removethemicrowavedrawer')) document.getElementById('Removethemicrowavedrawer').classList.remove('active')
                            if(document.getElementById('SMD2489ES')) document.getElementById('SMD2489ES').classList.add('active')
                            window.hotspotsList.setHotspotsActive([
                                { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                            ])
                           if(document.getElementById("microwaveDrawerOvensCategory-hotspotBtn")) document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').style.visibility = "visible"
                            
                        })
                    }, 2000);
                }
            }

            if (data.itemCategory == "wallOvenCategory") {
                if (data.cardDetails.title === "SWA2450GS" && data.productStateSelectContext.wallOvenPosition === "zoneSeven") {
                    data.productStateSelectContext.underTheCounterPedestalsCategory = "";
                    if (data.productStateSelectContext.underTheCounterPedestalsCategory === "Remove the pedestal") {
                        setTimeout(() => {
                            window.scene.applySequence(window['SKCD24U0GS_zone7_off'])
                        }, 1000)
                    }
                }
            }
              

            if(data.productStateSelectContext.wallOvenPosition != "zoneThree" && 
            (data.productStateSelectContext.wallOvenCategory != "SWA2450GS" || data.productStateSelectContext.wallOvenCategory != "SSC2489GS")
            // && data.productStateSelectContext.microwaveDrawerOvensCategory != "SMD2499FS"
            ){

                if(data.itemCategory == 'underTheCounterPedestalsCategory'){
                    if(data.cardDetails.title == "Remove the pedestal" || data.cardDetails.title == ""){
                        if(data.productStateSelectContext.pedestalsPosition === "zoneSeven"){
                            data.productStateSelectContext.currentProductVisibilitySequence = data.cardDetails.productVisibilitySequence;
                        }
                        }else if(data.productStateSelectContext.pedestalsPosition === "zoneThree"){
                            data.productStateSelectContext.currentProductVisibilitySequence = data.cardDetails.currentProductVisibilitySequencetwo;
                        }
                    }else{
                        data.productStateSelectContext.currentProductVisibilitySequence = data.cardDetails.productVisibilitySequence;
                    }
            }

            // if(data.productStateSelectContext.pedestalsPosition === "zoneSeven" && )

            // else if(data.cardDetails.title == "SMD2499FS"){
            //     data.productStateSelectContext.currentProductVisibilitySequence = "";
            // }


            // console.log("productVisibilitySequence 2713",data.cardDetails.productVisibilitySequence);
            // console.log("currentProductVisibilitySequence 2714",data.productStateSelectContext.currentProductVisibilitySequence);

            // if(data.productStateSelectContext.wallOvenPosition == "zoneSeven" && 
            // (data.productStateSelectContext.wallOvenCategory != "SWA2450GS" || data.productStateSelectContext.wallOvenCategory != "SSC2489GS")
            // // && data.productStateSelectContext.microwaveDrawerOvensCategory != "SMD2499FS"
            // ){

            //     // data.productStateSelectContext.currentProductVisibilitySequence = data.cardDetails.productVisibilitySequence;
            // }

            if (data.cardDetails.productVisibilitySequencetwo != "") {
                data.productStateSelectContext.currentProductVisibilitySequencetwo = data.cardDetails.productVisibilitySequencetwo;
            }
            if (data.itemCategory == 'wallOvenCategory') {
                data.productStateSelectContext.currentProductVisibilitySequencewalloven = data.cardDetails.productVisibilitySequence;
            }

            if (data.cardDetails.productVisibilitySequence == "A1_walloven_SSC2489GS_vis") {
                data.productStateSelectContext.cardClickDatainhandleAccordion = data.productStateSelectContext.currentProductVisibilitySequence
            }


            if (data.cardDetails.productVisibilitySequence == "LZ3_MICRODRAW_WALL_ON") {
                data.productStateSelectContext.microwaveVisibilityOffSequencefromProductCardClick = "LZ3_MICRODRAW_WALL_ON"
            }
            else {
                data.productStateSelectContext.microwaveVisibilityOffSequencefromProductCardClick = ""
            }

            // ----------------------------
            if (data.cardDetails.productVisibilitySequence == "B1_microdrawer_SMD2489ES_vis") {
                data.productStateSelectContext.microWaveSeqUpdateSMD2489ES = "B1_microdrawer_SMD2489ES_vis"
            }
            else if (data.itemCategory == "underTheCounterPedestalsCategory") {
                data.productStateSelectContext.microWaveSeqUpdateSMD2489ES = "B1_microdrawer_SMD2489ES_vis"
            }
            else {
                data.productStateSelectContext.microWaveSeqUpdateSMD2489ES = ""
            }
          
// ==================
            if (data.cardDetails.productVisibilitySequence == "B1_microdrawer_SMD2489ES_vis" && data.productId == "microwaveDrawerOvensCategoryproductId") {
                data.productStateSelectContext.microWaveSeqUpdateSMD2489ES = "B1_microdrawer_SMD2489ES_vis"
            }
            // ------------------
            else if (data.cardDetails.productVisibilitySequence == "C1_microdrawer_SMD2470AS_vis" && data.productId == "microwaveDrawerOvensCategoryproductId") {
                data.productStateSelectContext.microWaveSeqUpdateSMD2470AS = "C1_microdrawer_SMD2470AS_vis"
            }


            if (data.itemCategory == "wallOvenCategory"
                && data.productStateSelectContext.currentProductVisibilitySequence == "A1_walloven_SSC2489GS_vis") {
                data.productStateSelectContext.wallOven2489PopUp = "A1_walloven_SSC2489GS_vis"
            } else {
                data.productStateSelectContext.wallOven2489PopUp = ""
            }


            if (data.productStateSelectContext.currentProductVisibilitySequence == "A1_walloven_SSC2489GS_vis"
                && data.id == "underTheCounterPedestalsCategory"
            ) {
                data.productStateSelectContext.wallOven2489GSValue = "A1_walloven_SSC2489GS_vis"
            }
            else {
                data.productStateSelectContext.wallOven2489GSValue = ""
            }

            if (data.productStateSelectContext.wallOven2489PopUp == "A1_walloven_SSC2489GS_vis") {
                // popUp visibility
            }

// ---------------------------------------------------------------------------------------------
        let wallOventhree= document.getElementById('wallOvenCategorythree')   
        //  this line of code haws been executed on second click
      
        //ADDED FOR PEDESTIALS NONE IN ZONE 3
        // if(data.productStateSelectContext.pedestalsPosition == "zoneThree"
        //   && data.cardDetails.title === "Remove the pedestal" ){
                
        //             window.scene.applySequence(
        //                 window[data.cardDetails.productVisibilitySequencetwo], function () {
        //                     document.getElementById('productCategoryHotspot').style.display = 'none';
        //                     if (window.seqValue == true) {

        //                         currentTargetHotspot.classList.add('active')
        //                         currentTargetCallout.classList.add('active')
        //                     }
        //                 }
        //             )

        //         // }

        //  }
        //ADDED FOR PEDESTIALS NONE IN ZONE 3 END
// ----------------
            if (data.productStateSelectContext.wallOvenPosition == "zoneThree"
                && data.cardDetails.productVisibilitySequencetwo != "A1_SSC2489GS_Zone3"
                && data.cardDetails.productVisibilitySequencetwo != "B1_SWA2450GS_AST_Zone3" //this condition is added so that we can avoid the call of multiple seq here
                // && data.productStateSelectContext.wallOvenPosition != "zoneSeven"
                //   && data.cardDetails.productVisibilitySequence != data.cardDetails.productVisibilitySequencetwo
                && data.cardDetails.productVisibilitySequencetwo != ""
                //   && data.cardDetails.productVisibilitySequencetwo != "drawer_zone7_dummy"
                && data.cardDetails.productVisibilitySequencetwo != "SKCD24U0GS_zone7_on"
            ) {
                
                setTimeout(() => {
                    window.scene.applySequence(
                        window[data.cardDetails.productVisibilitySequencetwo], function () {
                            // document.getElementById('productCategoryHotspot').style.display = 'none';
                            if (window.seqValue == true) {
                                currentTargetHotspot.classList.add('active')
                                currentTargetCallout.classList.add('active')     //callout's active 
                            }
                        }
                    )
                }, 1000)
            }

            //#TPE
            // if (data.productStateSelectContext.wallOvenPosition == "zoneSeven"
            //     && data.cardDetails.productVisibilitySequencetwo != "A1_SSC2489GS_Zone3"
            //     && data.cardDetails.productVisibilitySequencetwo != "B1_SWA2450GS_AST_Zone3"
            //     //  && data.cardDetails.productVisibilitySequence != data.cardDetails.productVisibilitySequencetwo
            //     && data.cardDetails.productVisibilitySequencetwo != ""
            //     //  && data.cardDetails.productVisibilitySequencetwo != "drawer_zone7_dummy"
            //     && data.cardDetails.productVisibilitySequencetwo != "SKCD24U0GS_zone7_on"
            // ) {
            //     console.log("data.cardDetails.productVisibilitySequencetwo",data.cardDetails.productVisibilitySequencetwo);

            //  setTimeout(() => {
            //      window.scene.applySequence(
            //          window[data.cardDetails.productVisibilitySequencetwo], function () {
            //             //  document.getElementById('productCategoryHotspot').style.display = 'none';
            //              if (window.seqValue == true) {
            //                  currentTargetHotspot.classList.add('active')
            //                  // if(event.target.closest('button').id === 'underTheCounterPedestalsCategoryhotspotAndCalloutRemove' || event.target.closest('button').id === 'microwaveDrawerOvensCategoryhotspotAndCalloutRemove'){
            //                  //     currentTargetCallout.classList.remove('active')     //callout's active  \cmnt
            //                  //    }else{
            //                  currentTargetCallout.classList.add('active')     //callout's active 

            //                  //    }
            //              }
            //          }
            //      )
            //  }, 1000)
            //  //  }
            //  }

            if (data.productStateSelectContext.wallOvenPosition == "zoneThree"
                && data.cardDetails.productVisibilitySequencetwo != ""
                && data.cardDetails.productVisibilitySequencetwo != "SKCD24U0GS_zone7_on" // this line is added so that code won't execute this seq which basically takes cam from zone to to zoneseven otherwise
            ) {
                window.scene.applySequence(
                    window[data.cardDetails.productVisibilitySequencetwo], function () {
                        // document.getElementById('productCategoryHotspot').style.display = 'none';
                        if (document.getElementById('SSC2489GS-ControlPanel--btn') != null) document.getElementById('SSC2489GS-ControlPanel--btn').style.display = 'flex';
                        if (document.getElementById('SSC2489GS-OpenOven--btn') != null) document.getElementById('SSC2489GS-OpenOven--btn').style.display = 'flex';
                        if (document.getElementById('SSC2489GS-Installunderneaththecounter--btn') != null) document.getElementById('SSC2489GS-Installunderneaththecounter--btn').style.display = 'flex';
                        if (window.seqValue == true) {
                            currentTargetHotspot.classList.add('active')
                            // currentTargetCallout.classList.add('active')
                            // if(event.target.closest('button').id === 'underTheCounterPedestalsCategoryhotspotAndCalloutRemove' || event.target.closest('button').id === 'microwaveDrawerOvensCategoryhotspotAndCalloutRemove'){
                            //     currentTargetCallout.classList.remove('active')     //callout's active \cmnt
                            //    }else{
                            currentTargetCallout.classList.add('active')     //callout's active 
                        }
                    }
                )

                if (data.cardDetails.productVisibilitySequencetwo != "") {
                    data.productStateSelectContext.currentProductVisibilitySequencetwo = data.cardDetails.productVisibilitySequencetwo;
                }
                
                // data.productStateSelectContext.currentProductVisibilitySequence = data.cardDetails.productVisibilitySequence;
                // n ---> the condition present below, is to avoid the update the value of, vis seq of walloven:
                if(data.productStateSelectContext.wallOvenPosition != "zoneThree" && (data.productStateSelectContext.wallOvenCategory != "SWA2450GS" || data.productStateSelectContext.wallOvenCategory != "SSC2489GS")){
                    data.productStateSelectContext.currentProductVisibilitySequence = data.cardDetails.productVisibilitySequence;
                }

                data.productStateSelectContext.currentProductVisibilitySequencewalloven = data.cardDetails.productVisibilitySequence;

            }

            else if (data.productStateSelectContext.pedestalsPosition == "zoneSeven" && data.cardDetails.productVisibilitySequencetwo == "SKCD24U0GS_zone7_on") {
                window.scene.applySequence(
                    window[data.cardDetails.productVisibilitySequencetwo], function () {
                        if (window.seqValue == true) {
                            currentTargetHotspot.classList.add('active')
                            currentTargetCallout.classList.add('active')
                        }
                        data.productStateSelectContext.currentProductVisibilitySequence = "SKCD24U0GS_zone7_on";
                        data.productStateSelectContext.zoneSevenPedestalRemovedStatus = false;
                        
                    }
                )

            }

// ------------------------------------------------------------------------------------------------
        // -----------------------------------------------
        let getActiveCalloutAccordion = document.querySelector('.accordionContentContainer.expandCallout')
        let getOtherActiveCalloutAccordion = document.querySelector('.calloutsContainer.active .accordionHeading.active')

        if (getActiveCalloutAccordion != null) {
            getActiveCalloutAccordion.style.height = '0px'
            getActiveCalloutAccordion.classList.remove('expandCallout')
        }
        if (getOtherActiveCalloutAccordion != null) {
            getOtherActiveCalloutAccordion.classList.remove('active')
        }

        // --------------------

        // let getActiveHotspot= document.querySelector('.hotspotInternalBtn.active');

        // if(getActiveHotspot != null){
        //     getActiveHotspot.classList.remove('active');
        // }

        //Update Store 3D
            data.productStateSelectContext[data.cardDetails.categoryType] = data.cardDetails.title
            let getHotspotControlp = document.querySelector('.hotspotInternalBtn.active')
            let getHotspotControlpSpan = document.querySelector('.hotspotInternalBtn.active .internalhotspotText')

            if (getHotspotControlp != null) {
                let getHotspotControlpInfo = getHotspotControlp.getAttribute('data-info')
                if (getHotspotControlpInfo != null) {
                    let getHotspotControlpInfoJSON = JSON.parse(getHotspotControlpInfo)
                    // getHotspotControlp.innerHTML = getHotspotControlpInfoJSON.hotspotText;

                    getHotspotControlpSpan.innerHTML = getHotspotControlpInfoJSON.hotspotText
                }
                getHotspotControlp.classList.remove('active')
            }

            if (window.seqValue == false) {
                currentTargetHotspot.classList.add('active')
                currentTargetCallout.classList.add('active')
                setcalloutInfo(true);
            }

            document.querySelector('#internalCalloutsAndHotspots').style.display = 'block';
            setcalloutInfo(true);

            data.productStateSelectContext.previousId = data.productId

            setTimeout(() => {
                if (data.itemCategory == "microwaveDrawerOvensCategory") {
                    if (data.productStateSelectContext.microwaveDrawerOvensCategory == "Remove the microwave drawer") {
                        if (document.getElementById('microwaveDrawerOvensCategory-hotspotBtn') != null) document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').style.visibility = 'hidden';
                        if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = 'hidden';
                        return;
                    } else {
                        if (document.getElementById('microwaveDrawerOvensCategory-hotspotBtn') != null) document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').style.visibility = 'visible';
                        if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = 'visible';
                    }
                }
            }, 1000)
        }
        // data.productStateSelectContext.currentProductVisibilitySequence = data.cardDetails.productVisibilitySequence;
        if (data.itemCategory == "wallOvenCategory") {
            if (data.cardDetails.title === "SWA2450GS" && data.productStateSelectContext.wallOvenPosition === "zoneThree") {
                document.getElementById('SWA2450GS-OpenOven--btn').style.visibility = 'visible';
                document.getElementById('SWA2450GS-ControlPanel--btn').style.visibility = 'visible';
                document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.visibility = 'visible';
                if (document.getElementById('SWA2450GS-OpenOven--btn') != null) document.getElementById('SWA2450GS-OpenOven--btn').style.display = 'flex';
                if (document.getElementById('SWA2450GS-ControlPanel--btn') != null) document.getElementById('SWA2450GS-ControlPanel--btn').style.display = 'flex';
                if (document.getElementById('SWA2450GS-Installunderneaththecounter--btn') != null) document.getElementById('SWA2450GS-Installunderneaththecounter--btn').style.display = 'flex';
            }
        }    

        // checkForOverLay();
       
        handleHotspotsVisibility(data,event);

        setTimeout(() => {
            if(data.productStateSelectContext.underTheCounterPedestalsCategory === "SKMD24U0ES" && data.productStateSelectContext.pedestalsPosition === "zoneThree" && 
            data.productStateSelectContext.wallOvenPosition === "zoneSeven" && data.itemCategory === "underTheCounterPedestalsCategory"
            ){
             
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true },
                        { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
                    ])
                }, 100);

    }
        }, 2000);

        // console.log(data.cardDetails.title,'title----');
    }

    //function invoke on the zoomout button
    const ZoomOutreset = (event, data) => {


        setTimeout(()=>{
            window.hotspotsList.setHotspotsActive([
                // { hsname: "overRangeMicroCategory-hotspotBtn",isactive: false },
                { hsname: "cooktopCategory-hotspotBtn", isactive: true },
                { hsname: "dishwasherCategory-hotspotBtn", isactive: true },
                // { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true },
                { hsname: "overRangeMicroCategory-hotspotBtn", isactive: true },
                { hsname: "overTheCounterCategory-hotspotBtn", isactive: true },
                { hsname: "hoodRangeCategory-hotspotBtn", isactive: true },
                { hsname: "refrigeratorCategory-hotspotBtn", isactive: true },
                { hsname: "wallOvenCategory-hotspotBtn", isactive: true },
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true }
            ])

            if((data.underTheCounterPedestalsCategory !== "" && data.underTheCounterPedestalsCategory !== "Remove the pedestal")  && data.pedestalsPosition === "zoneThree"){
         
                window.hotspotsList.setHotspotsActive([
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true }
                ])
            }else if(data.pedestalsPosition == ""){
   
                window.hotspotsList.setHotspotsActive([
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                ])
            }else if(data.pedestalsPosition == "zoneSeven" && data.underTheCounterPedestalsCategory !== ""){
    
                window.hotspotsList.setHotspotsActive([
                    { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true },
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                ])
            }
        },2000)

        if(data.wallOvenPosition === "zoneThree" && data.wallOvenCategory === "SSC2489GS"){
            window.hotspotsList.setHotspotsActive([
                { hsname: "installWallovenInFrontSide-hotspotBtn", isactive: true },
            ])
        }

        if(data.underTheCounterPedestalsCategory == "" && data.pedestalsPosition === "zoneThree"){
           
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
            ])
        }
       
        if(data.microwaveDrawerOvensCategory != ""){
          
            setTimeout(()=>{
            window.hotspotsList.setHotspotsActive([
            { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
            ])
            if(document.getElementById('microwaveDrawerOvensCategory-hotspotBtn')) document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').style.visibility = "visible"
        },2500)
        }
        else if(data.microwaveDrawerOvensCategory == ""){
            window.hotspotsList.setHotspotsActive([
                { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false }
                ])
        }

       if(data.wallOvenCategory == "SWA2450GS" && data.wallOvenPosition == "zoneSeven"){

        setTimeout(()=>{
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                { hsname: "installWalloneOneInright-hotspotBtn", isactive: true },
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
            ])
        },2100)
       }

       if(data.wallOvenCategory == "SWA2450GS" && data.wallOvenPosition == "zoneThree"){
        setTimeout(()=>{
            window.hotspotsList.setHotspotsActive([
                // { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }
                { hsname: "installWalloneOneInright-hotspotBtn", isactive: false },
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                // installWallovenInrightSide-hotspotBtn
            ])
        },2000)
       }

       if(data.wallOvenCategory == "SSC2489GS" && data.wallOvenPosition == "zoneSeven" && data.pedestalsPosition !== "zoneThree" &&
       (data.underTheCounterPedestalsCategory != "Remove the pedestal" || data.underTheCounterPedestalsCategory != "")){
      
        setTimeout(()=>{
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true }
            ])
        },2000)
       }
       if(data.wallOvenCategory == "SSC2489GS" && data.wallOvenPosition == "zoneSeven"&& 
       (data.underTheCounterPedestalsCategory == "Remove the pedestal" || data.underTheCounterPedestalsCategory == "")){

        setTimeout(()=>{
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: true },
                { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: true }
            ])
        },2000)
       }
        
       if(data.wallOvenCategory == "SSC2489GS" && data.wallOvenPosition == "zoneThree"){
        setTimeout(() => {
            window.hotspotsList.setHotspotsActive([
                // { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false }
                // { hsname: "installWallovenOneInFront-hotspotBtn", isactive: false }
            ])
        }, 2000); // if the time is decrease it will affect the vis of hotpsot installWallovenInrightSide
       }

       if(data.wallOvenCategory == "SSC2489GS" && data.wallOvenPosition == "zoneThree"){
       
            window.hotspotsList.setHotspotsActive([
                // { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                { hsname: "installWallovenOneInFront-hotspotBtn", isactive: false }
            ])
       
       }

       for(let i=0; i < window.hotspotsList.hslist.length; i++){

        if (data.pedestalsPosition === "zoneSeven") {
            if(window.hotspotsList.hslist[i].hsname == "underTheCounterPedestalsCategory-hotspotBtn"){
                
                // console.log("window.hotspotsList.hslist[i].nameOf3dObj",window.hotspotsList.hslist[i].nameOf3dObj);
        //    if( window.hotspotsList.hslist[8]!=undefined) window.hotspotsList.hslist[8].nameOf3dObj = 'Pedestals_zone7_HOTSPOT'; //this is front hotspot name
        //    if( window.hotspotsList.hslist[i]!=undefined) window.hotspotsList.hslist[i].nameOf3dObj = 'Pedestals_zone7_HOTSPOT'; //this is front hotspot name
        //    console.log("window.hotspotsList.hslist[i].nameOf3dObj 3217",window.hotspotsList.hslist[i].nameOf3dObj);
            // window.hotspotsList.hslist[8].nameOf3dObj_right = 'Pedestals_HOTSPOT_01';
            }
        }

        if (data.pedestalsPosition == "zoneThree" && (data.underTheCounterPedestalsCategory !== "" && data.underTheCounterPedestalsCategory !== "Remove the pedestal")) {
          
            window.hotspotsList.setHotspotsActive([
                { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: true }
            ])
        }
        if (data.pedestalsPosition == "zoneThree") {
        }
       
        if (data.underTheCounterPedestalsCategory === "Remove the pedestal") {
            if(window.hotspotsList.hslist[i].hsname == "underTheCounterPedestalsCategory-hotspotBtn"){
            // if( window.hotspotsList.hslist[8]!=undefined) window.hotspotsList.hslist[8].nameOf3dObj = '';
            if( window.hotspotsList.hslist[i]!=undefined) window.hotspotsList.hslist[i].nameOf3dObj = '';
            }
        }

    }
        // "underTheCounterPedestalsCategory-hotspotBtn"
        if (document.getElementById('SJB1255GS-ControlPanelLight-btn') != null) document.getElementById('SJB1255GS-ControlPanelLight-btn').style.visibility = 'hidden';
        if (document.getElementById('SJB1255GS-CrisperFreshConverterDrawers-btn') != null) document.getElementById('SJB1255GS-CrisperFreshConverterDrawers-btn').style.visibility = 'hidden';

        //n this condition is added here, so that whenever the user go to pedestal in the right side, the cam will aplly using without reset seq
        if (data.pedestalsPosition === "zoneThree") {
            cameraNoResetMatrix['reset'] = ['drawer_cam', 'microdrawer_cam', 'WALLOVEN_ZONE3', 'drawer_zone7','reset']
        }

        //n this line of code is added here for the waloven, so that on reset call on the reset will be applied for these cam only
        if (data.wallOvenPosition === "zoneThree") {
            cameraNoResetMatrix['reset'] = ['drawer_cam', 'microdrawer_cam', 'WALLOVEN_ZONE3', 'drawer_zone7', 'walloven_cam','reset']
        }
        else if(data.wallOvenPosition === "zoneSeven"){
            cameraNoResetMatrix['reset'] = ['drawer_cam', 'microdrawer_cam', 'WALLOVEN_ZONE3', 'drawer_zone7','reset']
        }
       
        let camera = 'reset'
        let currentCamNoResetMatrix = cameraNoResetMatrix[camera];
        
        if (currentCamNoResetMatrix.indexOf(data.currentCam) != -1) {
            // camera = camera + '_without_reset';
            camera = 'Reset_without_reset';
        } else {
            camera = 'Reset';
        }
      
        // console.log(camera,'camera-----')
        window.resetCam(camera);

        let currentActiveCallout = document.querySelector('.calloutsContainer.active')
        if (currentActiveCallout != null) {
            currentActiveCallout.classList.remove('active')
        }
        let getHotspotControlp = document.querySelector('.hotspotContainer.active')
        if (getHotspotControlp != null) {
            getHotspotControlp.classList.remove('active')
        }
        if (data != undefined) {
            data.currentCam = 'reset'
        }
        setcalloutInfo(true)

        document.getElementById('internalCalloutsAndHotspots').style.display='none';

        for(let i=0; i < window.hotspotsList.hslist.length; i++){
     
            if(data.wallOvenPosition == "zoneThree"){
                if(window.hotspotsList.hslist[i].hsname == "wallOvenCategory-hotspotBtn"){       
            document.getElementById('wallOvenCategory-hotspotBtn').style.visibility="visible";
            // window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT_R'
            window.hotspotsList.hslist[i].nameOf3dObj = 'WALL_OVEN_HOTSPOT_R'
            }
            }

        if(data.wallOvenPosition == "zoneSeven"){
            if(window.hotspotsList.hslist[i].hsname == "wallOvenCategory-hotspotBtn"){
            document.getElementById('wallOvenCategory-hotspotBtn').style.visibility="visible";
            // window.hotspotsList.hslist[7].nameOf3dObj = 'WALL_OVEN_HOTSPOT'
            window.hotspotsList.hslist[i].nameOf3dObj = 'WALL_OVEN_HOTSPOT'
            }
        }

    }

        // for(let i=0; i < window.hotspotsList.hslist.length; i++){
        //     // window.hotspotsList.hslist[i].nameOf3dObj;
        //     console.log("window.hotspotsList.hslist[i].hsname",window.hotspotsList.hslist[i].hsname);
        //     console.log("window.hotspotsList.hslist[i].nameOf3dObj",window.hotspotsList.hslist[i].nameOf3dObj);
        // }
        // console.log("window.hotspotsList.hslist",window.hotspotsList.hslist.length);

        const activeAccordianContainer = document.querySelector('.accordionContentContainer.expand') && document.querySelector('.accordionContentContainer.expand');
        if(activeAccordianContainer){
            const iconId = activeAccordianContainer.classList[1]
            document.querySelector(`#${iconId}IconBtn`).classList.remove('active')
           activeAccordianContainer.previousSibling.firstElementChild.classList.remove('active')
            activeAccordianContainer.classList.remove('expand')
            activeAccordianContainer.style.height = "0px"

            let menuContainer = document.querySelector('.menuAccordion');
            menuContainer.scrollTop = 0

        }
        if(data.underTheCounterPedestalsCategory == "" && data.microwaveDrawerOvensCategory == "" &&
        data.currentCam =="reset" ){
            document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').style.visibility = "hidden";
            document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = "hidden";
        }

        if(data.previousCam == "range_hood_cam"){
            document.getElementById('hoodRangeCategory-hotspotBtn').style.visibility = "visible";
            document.getElementById('overRangeMicroCategory-hotspotBtn').style.visibility = "hidden";
        }else if(data.previousCam == "OVER_THE_RANGE"){
            document.getElementById('hoodRangeCategory-hotspotBtn').style.visibility = "hidden";
            document.getElementById('overRangeMicroCategory-hotspotBtn').style.visibility = "visible";
        }

         if(data.pedestalsPosition == 'zoneSeven'){
            data.underTheCounterPedestalsCategory = "SKCD24U0GS";
         }

         if(data.microwaveDrawerOvensCategory == "SMD2499FS" && data.pedestalsPosition === "zoneThree"){
            setTimeout(() => {
                window.hotspotsList.setHotspotsActive([
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: true }
                    ])
            }, 2000);
        }
        //Changes for removing active underTheCounterPedestalsCategory-hotspotBtn hotspot
        if((data.microwaveDrawerOvensCategory == "SMD2440JS" || data.microwaveDrawerOvensCategory == "SMD2479JS") && data.pedestalsPosition === "zoneThree" && data.wallOvenPosition === "zoneThree"){
            setTimeout(() => {
                window.hotspotsList.setHotspotsActive([
                    { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                    ])
                    if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = 'hidden';
                }, 2000);
        }
    
        if(data.pedestalsPosition == "zoneThree" && data.microwaveDrawerOvensCategory != "" 
            && (data.underTheCounterPedestalsCategory == "Remove the pedestal" || data.underTheCounterPedestalsCategory == "" )){
     
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                    ])
                 }, 1000);
            }


            //@SH24JAN24CF updated condition 
            if(data.microwaveDrawerOvensCategory != "" && data.pedestalsPosition === "zoneThree" && 
            (data.underTheCounterPedestalsCategory == "Remove the pedestal" || data.underTheCounterPedestalsCategory == "")
             && data.zoneSevenPedestalRemovedStatus !== true ){
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                        { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: false }
                        ])
                }, 3000);
            }   

            if(data.microwaveDrawerOvensCategory == "" && data.pedestalsPosition === "zoneThree" && (data.underTheCounterPedestalsCategory == "Remove the pedestal" || data.underTheCounterPedestalsCategory == "")){
     
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false }
                        ])
                }, 3000);
            }   

            if(data.microwaveDrawerOvensCategory == "" && data.pedestalsPosition === "zoneThree" && (data.underTheCounterPedestalsCategory == "Remove the pedestal" || data.underTheCounterPedestalsCategory == "")
                && data.previousId == "microwaveDrawerOvensCategoryhotspotAndCalloutRemove" && data.zoneSevenPedestalRemovedStatus !== true
            ){

                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                        ])
                        if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = 'visible';
                }, 3000);
            }   

            if((data.microwaveDrawerOvensCategory != "" || data.microwaveDrawerOvensCategory != "Remove the microwave drawer") && data.pedestalsPosition === "zoneThree"
            &&  (data.underTheCounterPedestalsCategory == "Remove the pedestal" || data.underTheCounterPedestalsCategory == "" || data.underTheCounterPedestalsCategory == "SKMD24U0ES")
            ){
           
                window.hotspotsList.hslist[8].nameOf3dObj = "Pedestals_zone7_HOTSPOT"
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true }
                        ])
                        // if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = 'visible';
                }, 2000);
            }   

            if(!data.zoneSevenPedestalRemovedStatus && data.pedestalsPosition == "zoneSeven" && data.zoneThreePedestalRemovedStatus.SKCD24U0GS === false && data.microwaveDrawerOvensCategory == "SMD2499FS"){
                setTimeout(() => {
                    window.scene.applySequence(window["LZ3_pedestal_vis_on"], function(){})
                },2000)
            }
            if(data.microwaveDrawerOvensCategory == "SMD2499FS" && data.pedestalsPosition === "zoneSeven" && data.underTheCounterPedestalsCategory === "SKCD24U0GS"){
            
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                        { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: true }
                        ])
                }, 1000);
              
            }

            if(!data.zoneSevenPedestalRemovedStatus && data.pedestalsPosition == "zoneSeven" && data.zoneThreePedestalRemovedStatus.SKMD24U0ES !== false){
              
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: true },
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                        ])
                        if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = 'visible';
                }, 2000);

                setTimeout(() => {
                        if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn')) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.opacity = 1;
                }, 3500);
            }

            //@SH24JAN24CF added this condition to hide extra hotspot for right side pedestal
            if(data.pedestalsPosition === "zoneSeven" && data.underTheCounterPedestalsCategory === "SKCD24U0GS" 
            && data.microwaveDrawerOvensCategory == "SMD2499FS"
            ){
           
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                        ])
                }, 2000);
            }

            if(data.zoneSevenPedestalRemovedStatus){
         
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategory-hotspotBtn", isactive: false },
                        { hsname: "remove_pedestal_zone_7-hotspotBtn", isactive: true }
                        ])
                        // if (document.getElementById('underTheCounterPedestalsCategory-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategory-hotspotBtn').style.visibility = 'visible';
                }, 2000);
            };

         

            //@SH24JAN24CF added this condition to show the install pedestal hotspot on right side when the pedestal is remvoed;
            if(data.zoneThreePedestalRemovedStatus.SKMD24U0ES){
                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false },
                        { hsname: "remove_pedestal_zone_3-hotspotBtn", isactive: true }
                        ])
                }, 2000);
            };

            if(data.microwaveDrawerOvensCategory === "" && data.wallOvenPosition == "zoneSeven"
            && data.underTheCounterPedestalsCategory === "SKCD24U0GS" && data.pedestalsPosition == "zoneSeven"
            ){
               

                setTimeout(() => {
                    window.hotspotsList.setHotspotsActive([
                        { hsname: "installmicrowaveDrawerOven-hotspotBtn", isactive: true }
                        ])
                }, 2000);
            }

            setTimeout(() => {

                if(!window.mob){
                    if(document.getElementById('internalCalloutsAndHotspots')) document.getElementById('internalCalloutsAndHotspots').style.display = "none";
                }

            }, 2000);

            if(window.mob){

                setTimeout(() => {
                    // window.hotspotsList.setHotspotsActive([
                    //     { hsname: "installWallovenInrightSide-hotspotBtn", isactive: false },
                    //     { hsname: "microwaveDrawerOvensCategory-hotspotBtn", isactive: false },
                    //     { hsname: "underTheCounterPedestalsCategoryRight-hotspotBtn", isactive: false }
                    //     ])
                        window.scene.clearRefine();
                        if(document.querySelector('.navigationMob')) document.querySelector('.navigationMob').style.display = "flex"
        
                        // if(data.wallOvenPosition == "zoneThree"){
                        //     window.hotspotsList.setHotspotsActive([
                        //         { hsname: "wallOvenCategory-hotspotBtn", isactive: true }
                        //         ])
                        // }

                }, 4000);
             };

             if(window.mob){
                
                if(document.querySelector('.zoomoutButtonNew')) document.querySelector('.zoomoutButtonNew').style.display = "none"
                if(document.getElementById('installWallovenInrightSide-hotspotBtn') != null) document.getElementById('installWallovenInrightSide-hotspotBtn').classList.add('mobresetzonethreehs');
                if(document.getElementById('microwaveDrawerOvensCategory-hotspotBtn') != null) document.getElementById('microwaveDrawerOvensCategory-hotspotBtn').classList.add('mobresetzonethreehs');
                if(document.getElementById('underTheCounterPedestalsCategoryRight-hotspotBtn') != null) document.getElementById('underTheCounterPedestalsCategoryRight-hotspotBtn').classList.add('mobresetzonethreehs');
                if(document.getElementById('remove_pedestal_zone_3-hotspotBtn') != null) document.getElementById('remove_pedestal_zone_3-hotspotBtn').classList.add('mobresetzonethreehs');
                if(document.getElementById('installmicrowaveDrawerOven-hotspotBtn') != null) document.getElementById('installmicrowaveDrawerOven-hotspotBtn').classList.add('mobresetzonethreehs');
                if(document.getElementById('installWalloneOneInright-hotspotBtn') != null) document.getElementById('installWalloneOneInright-hotspotBtn').classList.add('mobresetzonethreehs');
                // if(document.getElementById('wallOvenCategory-hotspotBtn') != null) document.getElementById('wallOvenCategory-hotspotBtn').classList.add('mobresetzonethreehs');
                
                 if(data.wallOvenPosition == "zoneThree"){
                     if(document.getElementById('wallOvenCategory-hotspotBtn') != null) document.getElementById('wallOvenCategory-hotspotBtn').classList.add('mobresetzonethreehs');
                }
            }

    }

    const closeRadiobtn = (event, data) => {
        let data3 = event.target.parentElement.parentElement;
        data3.style.visibility = 'hidden';
        document.querySelector(".popUpWidth").style.visibility = "hidden";
        document.querySelector(".compPopUpWidth").style.visibility = "hidden";
        document.querySelector(".compPopUpWidthWalloven").style.visibility = "hidden";
        setcalloutInfo(true)
    }

    return {
        myKitchenPopupVisibility,
        handleMyKitchenVisibility,
        howToNavigatePopupVisibility,
        handlehowToNavigateVisibility,
        mainMenuVisibility,
        handlehMainMenuVisibility,
        accordionExpand,
        handleAccordionExpand,
        productCardClicked,
        ZoomOutreset,
        calloutInfo,
        handleCalloutsInfo,
        calloutAccExpand,
        handleCalloutAccordion,
        hotspotClick,
        productCategoryHotspot,
        handleCalloutsInfoBtnHandler,
        closeRadiobtn
    }
}

export default DOMHandler
